(function ()
{
    'use strict';

    angular
        .module('app.users',
            [
                // 3rd Party Dependencies
                'datatables'
            ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.users', {
                url    : '/users',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/users/users.html',
                        controller : 'UsersController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.admin, USER_ROLES.god]
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/users');

        // Navigation
        msNavigationServiceProvider.saveItem('users', {
            title    : 'Users',
            icon     : 'icon-account',
            state    : 'app.users',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'USERS.USERS_NAV',
            weight   : 2
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.users')
        .controller('KycDialogController', KycDialogController);

    /** @ngInject */
    function KycDialogController($mdDialog, userKycDetails, api, $resource, session, $window)
    {
        var vm = this;

        // Data
        vm.userKycDetails = userKycDetails;
        vm.dataLoading = {};
        vm.countries = { 'AF':'Afghanistan','AX':'Aland Islands','AL':'Albania','DZ':'Algeria','AS':'American Samoa','AD':'Andorra','AO':'Angola','AI':'Anguilla','AQ':'Antarctica','AG':'Antigua And Barbuda','AR':'Argentina','AM':'Armenia','AW':'Aruba','AU':'Australia','AT':'Austria','AZ':'Azerbaijan','BS':'Bahamas','BH':'Bahrain','BD':'Bangladesh','BB':'Barbados','BY':'Belarus','BE':'Belgium','BZ':'Belize','BJ':'Benin','BM':'Bermuda','BT':'Bhutan','BO':'Bolivia','BA':'Bosnia And Herzegovina','BW':'Botswana','BV':'Bouvet Island','BR':'Brazil','IO':'British Indian Ocean Territory','BN':'Brunei Darussalam','BG':'Bulgaria','BF':'Burkina Faso','BI':'Burundi','KH':'Cambodia','CM':'Cameroon','CA':'Canada','CV':'Cape Verde','KY':'Cayman Islands','CF':'Central African Republic','TD':'Chad','CL':'Chile','CN':'China','CX':'Christmas Island','CC':'Cocos (Keeling) Islands','CO':'Colombia','KM':'Comoros','CG':'Congo','CD':'Congo,Democratic Republic','CK':'Cook Islands','CR':'Costa Rica','CI':'Cote D\'Ivoire','HR':'Croatia','CU':'Cuba','CY':'Cyprus','CZ':'Czech Republic','DK':'Denmark','DJ':'Djibouti','DM':'Dominica','DO':'Dominican Republic','EC':'Ecuador','EG':'Egypt','SV':'El Salvador','GQ':'Equatorial Guinea','ER':'Eritrea','EE':'Estonia','ET':'Ethiopia','FK':'Falkland Islands (Malvinas)','FO':'Faroe Islands','FJ':'Fiji','FI':'Finland','FR':'France','GF':'French Guiana','PF':'French Polynesia','TF':'French Southern Territories','GA':'Gabon','GM':'Gambia','GE':'Georgia','DE':'Germany','GH':'Ghana','GI':'Gibraltar','GR':'Greece','GL':'Greenland','GD':'Grenada','GP':'Guadeloupe','GU':'Guam','GT':'Guatemala','GG':'Guernsey','GN':'Guinea','GW':'Guinea-Bissau','GY':'Guyana','HT':'Haiti','HM':'Heard Island & Mcdonald Islands','VA':'Holy See (Vatican City State)','HN':'Honduras','HK':'Hong Kong','HU':'Hungary','IS':'Iceland','IN':'India','ID':'Indonesia','IR':'Iran,Islamic Republic Of','IQ':'Iraq','IE':'Ireland','IM':'Isle Of Man','IL':'Israel','IT':'Italy','JM':'Jamaica','JP':'Japan','JE':'Jersey','JO':'Jordan','KZ':'Kazakhstan','KE':'Kenya','KI':'Kiribati','KR':'Korea','KW':'Kuwait','KG':'Kyrgyzstan','LA':'Lao People\'s Democratic Republic','LV':'Latvia','LB':'Lebanon','LS':'Lesotho','LR':'Liberia','LY':'Libyan Arab Jamahiriya','LI':'Liechtenstein','LT':'Lithuania','LU':'Luxembourg','MO':'Macao','MK':'Macedonia','MG':'Madagascar','MW':'Malawi','MY':'Malaysia','MV':'Maldives','ML':'Mali','MT':'Malta','MH':'Marshall Islands','MQ':'Martinique','MR':'Mauritania','MU':'Mauritius','YT':'Mayotte','MX':'Mexico','FM':'Micronesia,Federated States Of','MD':'Moldova','MC':'Monaco','MN':'Mongolia','ME':'Montenegro','MS':'Montserrat','MA':'Morocco','MZ':'Mozambique','MM':'Myanmar','NA':'Namibia','NR':'Nauru','NP':'Nepal','NL':'Netherlands','AN':'Netherlands Antilles','NC':'New Caledonia','NZ':'New Zealand','NI':'Nicaragua','NE':'Niger','NG':'Nigeria','NU':'Niue','NF':'Norfolk Island','MP':'Northern Mariana Islands','NO':'Norway','OM':'Oman','PK':'Pakistan','PW':'Palau','PS':'Palestinian Territory,Occupied','PA':'Panama','PG':'Papua New Guinea','PY':'Paraguay','PE':'Peru','PH':'Philippines','PN':'Pitcairn','PL':'Poland','PT':'Portugal','PR':'Puerto Rico','QA':'Qatar','RE':'Reunion','RO':'Romania','RU':'Russian Federation','RW':'Rwanda','BL':'Saint Barthelemy','SH':'Saint Helena','KN':'Saint Kitts And Nevis','LC':'Saint Lucia','MF':'Saint Martin','PM':'Saint Pierre And Miquelon','VC':'Saint Vincent And Grenadines','WS':'Samoa','SM':'San Marino','ST':'Sao Tome And Principe','SA':'Saudi Arabia','SN':'Senegal','RS':'Serbia','SC':'Seychelles','SL':'Sierra Leone','SG':'Singapore','SK':'Slovakia','SI':'Slovenia','SB':'Solomon Islands','SO':'Somalia','ZA':'South Africa','GS':'South Georgia And Sandwich Isl.','ES':'Spain','LK':'Sri Lanka','SD':'Sudan','SR':'Suriname','SJ':'Svalbard And Jan Mayen','SZ':'Swaziland','SE':'Sweden','CH':'Switzerland','SY':'Syrian Arab Republic','TW':'Taiwan','TJ':'Tajikistan','TZ':'Tanzania','TH':'Thailand','TL':'Timor-Leste','TG':'Togo','TK':'Tokelau','TO':'Tonga','TT':'Trinidad And Tobago','TN':'Tunisia','TR':'Turkey','TM':'Turkmenistan','TC':'Turks And Caicos Islands','TV':'Tuvalu','UG':'Uganda','UA':'Ukraine','AE':'United Arab Emirates','GB':'United Kingdom','US':'United States','UM':'United States Outlying Islands','UY':'Uruguay','UZ':'Uzbekistan','VU':'Vanuatu','VE':'Venezuela','VN':'Viet Nam','VG':'Virgin Islands,British','VI':'Virgin Islands,U.S.','WF':'Wallis And Futuna','EH':'Western Sahara','YE':'Yemen','ZM':'Zambia','ZW':'Zimbabwe' };
        vm.isReasonAdded = false;

        // Methods
        vm.approve = approve;
        vm.decline = decline;
        vm.closeDialog = closeDialog;
        vm.addDeclineMessage = addDeclineMessage;
        vm.openImage = openImage;

        //////////
        function approve(e) {
            e.preventDefault();
            vm.dataLoading.approve = true;

            var formData = new FormData();
            formData.append('action', 'approve');
            formData.append('id', vm.userKycDetails.kyc.id);
            formData.append('token', session.token);

            api.kycStatus.setKycStatus(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        vm.dataLoading.approve = false;
                        closeDialog();
                    } else {
                        vm.dataLoading.approve = false;
                        api.showToast('error', response.message[0]);
                    }
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        function decline(e) {
            e.preventDefault();
            vm.dataLoading.decline = true;

            var formData = new FormData(document.getElementById('declineForm'));
            formData.append('action', 'decline');
            formData.append('id', vm.userKycDetails.kyc.id);
            formData.append('token', session.token);

            api.kycStatus.setKycStatus(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        vm.dataLoading.decline = false;
                        closeDialog();
                    } else {
                        vm.dataLoading.decline = false;
                        api.showToast('error', response.message[0]);
                    }
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        function addDeclineMessage(reason) {
            var reasons = {
                "fake": "Fake documents",
                "blurred": "Blurred documents",
                "unsupported": "Unsupported country",
                "duplicate": "Duplicate documents",
                "resolution": "Resolution is too small"};

            vm.decline_message = (vm.decline_message?vm.decline_message:'')+(vm.isReasonAdded?'':'Reason:\n')+reasons[reason]+'\n';
            vm.isReasonAdded = true;
        }

        function openImage(imageId) {
            $window.open('/api/documents/'+vm.userKycDetails.kyc.images[imageId], '_blank');
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        // API resources
        api.kycStatus = $resource(null, null, {
            'setKycStatus': {
                method          : 'POST',
                url             : api.baseUrl+'users/kyc_status',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.purchases', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.purchases', {
                url    : '/purchases',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/purchases/purchases.html',
                        controller : 'PurchasesController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.admin, USER_ROLES.god]
                }
                ,
                resolve  : {
                    PurchasesData: function (msApi)
                    {
                        return msApi.resolve('purchases@getPurchasesData');
                    }
                }
            });

        // Api
        msApiProvider.register('purchases', ['offline_mintage', null, {
            'getPurchasesData': {
                method          : 'GET',
                withCredentials : true
            }
        }]);

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/purchases');

        // Navigation
        msNavigationServiceProvider.saveItem('purchases', {
            title    : 'Purchases',
            icon     : 'icon-cart-outline',
            state    : 'app.purchases',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'PURCHASES.PURCHASES_NAV',
            weight   : 4
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.purchases')
        .controller('AddOfflineSaleDialogController', AddOfflineSaleDialogController);

    /** @ngInject */
    function AddOfflineSaleDialogController($mdDialog, offlineSaleDetails, api, $http, $resource)
    {
        var vm = this;

        // Data
        vm.offlineSaleDetails = offlineSaleDetails;
        vm.dataLoading = {};
        vm.offlineSaleDetails.currenciesArray = Object.keys(vm.offlineSaleDetails.currencies)
            .map(function(key) {
                return vm.offlineSaleDetails.currencies[key];
            });

        // Methods
        vm.closeDialog = closeDialog;
        vm.addOfflineSale = addOfflineSale;
        vm.findUser = findUser;
        vm.getRecentPurchases = getRecentPurchases;
        vm.getCurrencyRate = getCurrencyRate;
        vm.processReceiverInput = processReceiverInput;
        vm.tryCalculateMintage = tryCalculateMintage;
        //////////

        function findUser(query){
            return $http({
                method: 'POST',
                url: api.baseUrl+'users/list',
                data: "draw=1&start=0&length=5&search[value]="+query,
                headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
            })
                .then(function(response){
                    return response.data.data.data;
                })
        }

        function getRecentPurchases(userId){
            return $http.get(api.baseUrl+'offline_mintage/recent_purchases_for_user', {params: {id: userId}})
                .then(function(response){
                    vm.offlineSaleDetails.recentUserPurchases = response.data.data;
                    return response.data.data;
                })
        }

        function getCurrencyRate(currencyCode) {
            if (currencyCode)
                return vm.offlineSaleDetails.exchangeRates[currencyCode.toLowerCase()].toString();
        }

        function addOfflineSale(e) {
            e.preventDefault();
            vm.dataLoading.addOfflineSale = true;

            var formData = new FormData(document.getElementById('addOfflineSaleForm'));
            formData.append('payment_currency_id', vm.offlineSaleDetails.selectedCurrency.id);
            if (vm.receiverId)
                formData.append('buyer_user_id', vm.receiverId);
            if (vm.receiverEmail)
                formData.append('buyer_email', vm.receiverEmail);
            if (vm.receiverEthAddr)
                formData.append('buyer_ether_address', vm.receiverEthAddr);

            api.purchaseDialog.addOfflineSale(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        vm.dataLoading.addOfflineSale = false;
                        closeDialog();
                        api.showToast('success', response.message[0]);
                    } else {
                        vm.dataLoading.addOfflineSale = false;
                        api.showToast('error', response.message[0]);
                    }
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        function processReceiverInput(receiverSearchText, receiverObject) {
            vm.receiverId = null;
            vm.receiverEmail = null;
            vm.receiverId = null;
            if (!receiverObject) {
                var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var ethAddrRegex = /^(0x)?[0-9a-fA-F]{40}$/;
                if (emailRegex.test(String(receiverSearchText).toLowerCase())) {
                    vm.receiverHint = 'This user is not registered yet. Ask user to restore password after adding this purchase to access his account.';
                    vm.receiverEmail = String(receiverSearchText).toLowerCase();
                }
                else if(ethAddrRegex.test(String(receiverSearchText))) {
                    vm.receiverHint = 'This user is not registered yet. Ask user to sign up after adding this purchase.';
                    vm.receiverEthAddr = String(receiverSearchText);
                } else {
                    vm.receiverHint = null;
                }

                return (vm.receiverHint)
            } else
                vm.receiverId = receiverObject.id;
        }

        function tryCalculateMintage() {
            if (vm.offlineSaleDetails.selectedCurrency &&
                vm.offlineSaleDetails.selectedCurrency.id &&
                vm.offlineSaleDetails.amount &&
                (vm.offlineSaleDetails.exchangeRateText || vm.offlineSaleDetails.selectedCurrency.id == vm.offlineSaleDetails.tokenPriceCurrencyId) &&
                vm.offlineSaleDetails.tokenPriceText &&
                vm.offlineSaleDetails.tokenBonusText) {

                if(vm.offlineSaleDetails.selectedCurrency.id == vm.offlineSaleDetails.tokenPriceCurrencyId)
                    vm.offlineSaleDetails.exchangeRateText = 1;

                return $http({
                    method: 'POST',
                    url: api.baseUrl + 'offline_mintage/calculate',
                    data:
                    'payment_currency_id='+vm.offlineSaleDetails.selectedCurrency.id+
                    '&payment_amount='+vm.offlineSaleDetails.amount+
                    '&payment_currency_rate='+vm.offlineSaleDetails.exchangeRateText+
                    '&token_price='+vm.offlineSaleDetails.tokenPriceText+
                    '&bonus='+vm.offlineSaleDetails.tokenBonusText,
                    headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
                })
                    .then(function (response) {
                        if (response.data.success) {
                            vm.calculatedMintageAmount = response.data.data;
                            return response.data.data;
                        } else
                            vm.calculatedMintageAmount = null;
                    })
            } else
                vm.calculatedMintageAmount = null;
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        // API resources
        api.purchaseDialog = $resource(null, null, {
            'addOfflineSale': {
                method          : 'POST',
                url             : api.baseUrl+'offline_mintage/add',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [
            'vcRecaptcha'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, USER_ROLES, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.login', {
            url      : '/login',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            data: {
                authorizedRoles: [USER_ROLES.guest]
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/login');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($state, $rootScope, session, AUTH_EVENTS, api, icoConfig, vcRecaptchaService)
    {
        var vm = this;

        // Data
        vm.site = icoConfig.getConfig('site');
        vm.recaptcha = icoConfig.getConfig('recaptcha');
        vm.clientCountry = session.clientCountry;

        // Methods
        vm.login = login;
        vm.setWidgetId = setWidgetId;

        //////////

        function setWidgetId(widgetId) {
            vm.widgetId = widgetId;
        }

        function login(e) {
            e.preventDefault();
            vm.dataLoading = true;
            var formData = new FormData(document.getElementById('loginForm'));
            formData.append('token', session.token);

            api.auth.login(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        session.create(response.data);
                        $rootScope.$broadcast(AUTH_EVENTS.loginSuccess, response.data);
                        $state.go('app.overview');
                    } else {
                        if (response.data.two_factor_needed){
                            vm.twoFactor = response.data.two_factor_needed;
                        } else {
                            if (vm.site.isCaptchaEnabled)
                                vcRecaptchaService.reload(vm.widgetId);
                            api.showToast('error', response.message[0]);
                            $rootScope.$broadcast(AUTH_EVENTS.loginFailed);
                        }
                        vm.dataLoading = false;
                    }
                },
                //error
                function(){
                    if (vm.site.isCaptchaEnabled)
                        vcRecaptchaService.reload(vm.widgetId);
                    $rootScope.$broadcast(AUTH_EVENTS.loginFailed);
                    vm.dataLoading = false;
                }
            );
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('ICO.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('ICO.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('ICO.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
/**
 * @ngdoc module
 * @name material.components.slider
 */
SliderDirective.$inject = ["$$rAF", "$window", "$mdAria", "$mdUtil", "$mdConstant", "$mdTheming", "$mdGesture", "$parse", "$log", "$timeout"];
angular
    .module('app.core')
    .directive('msSlider', SliderDirective)
    .directive('msSliderContainer', SliderContainerDirective);

/**
 * @ngdoc directive
 * @name msSliderContainer
 * @module material.components.slider
 * @restrict E
 * @description
 * The `<ms-slider-container>` contains slider with two other elements.
 *
 *
 * @usage
 * <h4>Normal Mode</h4>
 * <hljs lang="html">
 * </hljs>
 */
function SliderContainerDirective() {
    return {
        controller: function () {},
        compile: function (elem) {
            var slider = elem.find('ms-slider');

            if (!slider) {
                return;
            }

            var vertical = slider.attr('ms-vertical');

            if (vertical !== undefined) {
                elem.attr('ms-vertical', '');
            }

            if(!slider.attr('flex')) {
                slider.attr('flex', '');
            }

            return function postLink(scope, element, attr, ctrl) {
                element.addClass('_md');     // private md component indicator for styling

                // We have to manually stop the $watch on ngDisabled because it exists
                // on the parent scope, and won't be automatically destroyed when
                // the component is destroyed.
                function setDisable(value) {
                    element.children().attr('disabled', value);
                    element.find('input').attr('disabled', value);
                }

                var stopDisabledWatch = angular.noop;

                if (attr.disabled) {
                    setDisable(true);
                }
                else if (attr.ngDisabled) {
                    stopDisabledWatch = scope.$watch(attr.ngDisabled, function (value) {
                        setDisable(value);
                    });
                }

                scope.$on('$destroy', function () {
                    stopDisabledWatch();
                });

                var initialMaxWidth;

                ctrl.fitInputWidthToTextLength = function (length) {
                    var input = element[0].querySelector('md-input-container');

                    if (input) {
                        var computedStyle = getComputedStyle(input);
                        var minWidth = parseInt(computedStyle.minWidth);
                        var padding = parseInt(computedStyle.padding) * 2;

                        initialMaxWidth = initialMaxWidth || parseInt(computedStyle.maxWidth);
                        var newMaxWidth = Math.max(initialMaxWidth, minWidth + padding + (minWidth / 2 * length));

                        input.style.maxWidth = newMaxWidth + 'px';
                    }
                };
            };
        }
    };
}

/**
 * @ngdoc directive
 * @name msSlider
 * @module material.components.slider
 * @restrict E
 * @description
 * The `<ms-slider>` component allows the user to choose from a range of
 * values.
 *
 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
 * the slider is in the accent color by default. The primary color palette may be used with
 * the `ms-primary` class.
 *
 * It has two modes: 'normal' mode, where the user slides between a wide range
 * of values, and 'discrete' mode, where the user slides between only a few
 * select values.
 *
 * To enable discrete mode, add the `ms-discrete` attribute to a slider,
 * and use the `step` attribute to change the distance between
 * values the user is allowed to pick.
 *
 * @usage
 * <h4>Normal Mode</h4>
 * <hljs lang="html">
 * <ms-slider ng-model="myValue" min="5" max="500">
 * </ms-slider>
 * </hljs>
 * <h4>Discrete Mode</h4>
 * <hljs lang="html">
 * <ms-slider ms-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
 * </ms-slider>
 * </hljs>
 * <h4>Invert Mode</h4>
 * <hljs lang="html">
 * <ms-slider ms-invert ng-model="myValue" step="10" min="10" max="130">
 * </ms-slider>
 * </hljs>
 *
 * @param {boolean=} ms-discrete Whether to enable discrete mode.
 * @param {boolean=} ms-invert Whether to enable invert mode.
 * @param {number=} step The distance between values the user is allowed to pick. Default 1.
 * @param {number=} min The minimum value the user is allowed to pick. Default 0.
 * @param {number=} max The maximum value the user is allowed to pick. Default 100.
 * @param {number=} round The amount of numbers after the decimal point, maximum is 6 to prevent scientific notation. Default 3.
 */
function SliderDirective($$rAF, $window, $mdAria, $mdUtil, $mdConstant, $mdTheming, $mdGesture, $parse, $log, $timeout) {
    // **********************************************************
    // Data
    // **********************************************************
    var vm = this;
    vm.groups = [];
    return {
        scope: {},
        require: ['?ngModel', '?^msSliderContainer'],
        template:
        '<div class="ms-slider-wrapper">' +
        '<div class="ms-slider-content">' +
        '<div class="ms-track-container">' +
        '<div class="ms-track"></div>' +
        '<div class="ms-track ms-track-fill"></div>' +
        '<div class="ms-track-ticks"></div>' +
        '</div>' +
        '<div class="ms-thumb-container">' +
        '<div class="ms-thumb"></div>' +
        '<div class="ms-focus-thumb"></div>' +
        '<div class="ms-focus-ring"></div>' +
        '<div class="ms-sign">' +
        '<span class="ms-thumb-text"></span>' +
        '</div>' +
        '<div class="ms-disabled-thumb"></div>' +
        '</div>' +
        '</div>' +
        '</div>',
        compile: compile
    };

    // **********************************************************
    // Private Methods
    // **********************************************************

    function compile (tElement, tAttrs) {
        var wrapper = angular.element(tElement[0].getElementsByClassName('ms-slider-wrapper'));

        var tabIndex = tAttrs.tabindex || 0;
        wrapper.attr('tabindex', tabIndex);

        if (tAttrs.disabled || tAttrs.ngDisabled) wrapper.attr('tabindex', -1);

        wrapper.attr('role', 'slider');

        $mdAria.expect(tElement, 'aria-label');

        return postLink;
    }

    function postLink(scope, element, attr, ctrls) {
        $mdTheming(element);
        var ngModelCtrl = ctrls[0] || {
                // Mock ngModelController if it doesn't exist to give us
                // the minimum functionality needed
                $setViewValue: function(val) {
                    this.$viewValue = val;
                    this.$viewChangeListeners.forEach(function(cb) { cb(); });
                },
                $parsers: [],
                $formatters: [],
                $viewChangeListeners: []
            };

        var containerCtrl = ctrls[1];
        var container = angular.element($mdUtil.getClosest(element, '_ms-slider-container', true));
        var isDisabled = attr.ngDisabled ? angular.bind(null, $parse(attr.ngDisabled), scope.$parent) : function () {
            return element[0].hasAttribute('disabled');
        };

        var thumb = angular.element(element[0].querySelector('.ms-thumb'));
        var thumbText = angular.element(element[0].querySelector('.ms-thumb-text'));
        var thumbContainer = thumb.parent();
        var trackContainer = angular.element(element[0].querySelector('.ms-track-container'));
        var activeTrack = angular.element(element[0].querySelector('.ms-track-fill'));
        var tickContainer = angular.element(element[0].querySelector('.ms-track-ticks'));
        var wrapper = angular.element(element[0].getElementsByClassName('ms-slider-wrapper'));
        var content = angular.element(element[0].getElementsByClassName('ms-slider-content'));
        var throttledRefreshDimensions = $mdUtil.throttle(refreshSliderDimensions, 5000);

        // Default values, overridable by attrs
        var DEFAULT_ROUND = 3;
        var vertical = angular.isDefined(attr.msVertical);
        var discrete = angular.isDefined(attr.msDiscrete);
        var invert = angular.isDefined(attr.msInvert);
        angular.isDefined(attr.min) ? attr.$observe('min', updateMin) : updateMin(0);
        angular.isDefined(attr.max) ? attr.$observe('max', updateMax) : updateMax(100);
        angular.isDefined(attr.shared) ? attr.$observe('shared', updateShared) : null;
        angular.isDefined(attr.step) ? attr.$observe('step', updateStep) : updateStep(1);
        angular.isDefined(attr.round)? attr.$observe('round', updateRound) : updateRound(DEFAULT_ROUND);
        angular.isDefined(attr.group)? attr.$observe('group', updateGroup) : null;

        // We have to manually stop the $watch on ngDisabled because it exists
        // on the parent scope, and won't be automatically destroyed when
        // the component is destroyed.
        var stopDisabledWatch = angular.noop;
        if (attr.ngDisabled) {
            stopDisabledWatch = scope.$parent.$watch(attr.ngDisabled, updateAriaDisabled);
        }

        $mdGesture.register(wrapper, 'drag', { horizontal: !vertical });

        scope.mouseActive = false;
        wrapper
            .on('keydown', keydownListener)
            .on('mousedown', mouseDownListener)
            .on('focus', focusListener)
            .on('blur', blurListener)
            .on('$md.pressdown', onPressDown)
            .on('$md.pressup', onPressUp)
            .on('$md.dragstart', onDragStart)
            .on('$md.drag', onDrag)
            .on('$md.dragend', onDragEnd);

        // On resize, recalculate the slider's dimensions and re-render
        function updateAll() {
            refreshSliderDimensions();
            ngModelRender();
        }
        setTimeout(updateAll, 0);

        var debouncedUpdateAll = $$rAF.throttle(updateAll);
        angular.element($window).on('resize', debouncedUpdateAll);

        scope.$on('$destroy', function() {
            angular.element($window).off('resize', debouncedUpdateAll);
            vm.groups = [];
        });

        ngModelCtrl.$render = ngModelRender;
        ngModelCtrl.$viewChangeListeners.push(ngModelRender);
        ngModelCtrl.$formatters.push(minMaxValidator);
        ngModelCtrl.$formatters.push(stepValidator);

        /**
         * Attributes
         */
        var min;
        var max;
        var shared;
        var step;
        var round;
        var group;
        function updateMin(value) {
            min = parseFloat(value);
            element.attr('aria-valuemin', value);
            updateAll();
        }
        function updateMax(value) {
            max = parseFloat(value);
            element.attr('aria-valuemax', value);
            updateAll();
        }
        function updateShared(value) {
            shared = parseFloat(value);
            element.attr('aria-valueshared', value);
            updateAll();
        }
        function updateStep(value) {
            step = parseFloat(value);
        }
        function updateRound(value) {
            // Set max round digits to 6, after 6 the input uses scientific notation
            round = minMaxValidator(parseInt(value), 0, 6);
        }
        function updateGroup(value) {
            if(typeof(value) !== 'undefined' && value != null){
                group = value;
                updateAll();

                if(typeof(vm.groups[value]) === 'undefined' || vm.groups[value] == null){
                    vm.groups[value] = [];
                    vm.groups[value].sliders = [];
                    vm.groups[value].order = [];
                }
                vm.groups[value].sliders.push({element:element, ngModelCtrl:ngModelCtrl});
                vm.groups[value].order.push(vm.groups[value].sliders.length-1);
            }

        }
        function updateAriaDisabled() {
            element.attr('aria-disabled', !!isDisabled());
        }

        // Draw the ticks with canvas.
        // The alternative to drawing ticks with canvas is to draw one element for each tick,
        // which could quickly become a performance bottleneck.
        var tickCanvas, tickCtx;
        function redrawTicks() {
            if (!discrete || isDisabled()) return;
            if ( angular.isUndefined(step) )         return;

            if ( step <= 0 ) {
                var msg = 'Slider step value must be greater than zero when in discrete mode';
                $log.error(msg);
                throw new Error(msg);
            }

            var numSteps = Math.floor( (max - min) / step );
            if (!tickCanvas) {
                tickCanvas = angular.element('<canvas>').css('position', 'absolute');
                tickContainer.append(tickCanvas);

                tickCtx = tickCanvas[0].getContext('2d');
            }

            var dimensions = getSliderDimensions();

            // If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
            if (dimensions && !dimensions.height && !dimensions.width) {
                refreshSliderDimensions();
                dimensions = sliderDimensions;
            }

            tickCanvas[0].width = dimensions.width;
            tickCanvas[0].height = dimensions.height;

            var distance;
            for (var i = 0; i <= numSteps; i++) {
                var trackTicksStyle = $window.getComputedStyle(tickContainer[0]);
                tickCtx.fillStyle = trackTicksStyle.color || 'black';

                distance = Math.floor((vertical ? dimensions.height : dimensions.width) * (i / numSteps));

                tickCtx.fillRect(vertical ? 0 : distance - 1,
                    vertical ? distance - 1 : 0,
                    vertical ? dimensions.width : 2,
                    vertical ? 2 : dimensions.height);
            }
        }

        function clearTicks() {
            if(tickCanvas && tickCtx) {
                var dimensions = getSliderDimensions();
                tickCtx.clearRect(0, 0, dimensions.width, dimensions.height);
            }
        }

        /**
         * Refreshing Dimensions
         */
        var sliderDimensions = {};
        refreshSliderDimensions();
        function refreshSliderDimensions() {
            sliderDimensions = trackContainer[0].getBoundingClientRect();
        }
        function getSliderDimensions() {
            throttledRefreshDimensions();
            return sliderDimensions;
        }

        /**
         * left/right/up/down arrow listener
         */
        function keydownListener(ev) {
            if (isDisabled()) return;

            var changeAmount;
            if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.DOWN_ARROW : ev.keyCode === $mdConstant.KEY_CODE.LEFT_ARROW) {
                changeAmount = -step;
            } else if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.UP_ARROW : ev.keyCode === $mdConstant.KEY_CODE.RIGHT_ARROW) {
                changeAmount = step;
            }
            changeAmount = invert ? -changeAmount : changeAmount;
            if (changeAmount) {
                if (ev.metaKey || ev.ctrlKey || ev.altKey) {
                    changeAmount *= 4;
                }
                ev.preventDefault();
                ev.stopPropagation();
                scope.$evalAsync(function() {
                    setModelValue(ngModelCtrl.$viewValue + changeAmount);
                });
            }
        }

        function mouseDownListener(ev) {
            ev.preventDefault();
            redrawTicks();
            scope.mouseActive = true;
            wrapper.removeClass('ms-focused');

            $timeout(function() {
                scope.mouseActive = false;
            }, 100);
        }

        function focusListener() {
            if (scope.mouseActive === false) {
                wrapper.addClass('ms-focused');
            }
        }

        function blurListener() {
            wrapper.removeClass('ms-focused');
            element.removeClass('ms-active');
            clearTicks();
        }

        /**
         * ngModel setters and validators
         */
        function setModelValue(value) {
            ngModelCtrl.$setViewValue( minMaxValidator(stepValidator(value)) );
            //Shared slider?
            if(angular.isDefined(attr.group) && vm.groups[attr.group].sliders.length > 1) {

                var currentSharedSliderId = getCurrentSharedSliderId();
                var index = currentSharedSliderId;
                var excess = shared;

                angular.forEach(vm.groups[attr.group].sliders, function(slider) {
                    excess -= slider.ngModelCtrl.$viewValue;
                });
                if (currentSharedSliderId != vm.groups[attr.group].order[vm.groups[attr.group].order.length-1]){
                    vm.groups[attr.group].order.splice(vm.groups[attr.group].order.indexOf(currentSharedSliderId), 1);
                    vm.groups[attr.group].order.push(currentSharedSliderId);
                }

                for (var i = 0; i < vm.groups[attr.group].sliders.length; i++) {
                    if (index != currentSharedSliderId) {
                        var slider = vm.groups[attr.group].sliders[index];
                        var val = slider.ngModelCtrl.$viewValue;
                        var newVal = 0;

                        newVal = Math.min(Math.max(val + excess, slider.element.attr('aria-valuemin')), slider.element.attr('aria-valuemax'));
                        slider.ngModelCtrl.$setViewValue(newVal);
                        excess -= (newVal - val);
                        if (excess == 0)
                            break;
                    }

                    index = vm.groups[attr.group].order[i];
                }
            }
        }

        function ngModelRender() {
            if (isNaN(ngModelCtrl.$viewValue)) {
                ngModelCtrl.$viewValue = ngModelCtrl.$modelValue;
            }

            ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$viewValue);

            var percent = valueToPercent(ngModelCtrl.$viewValue);
            scope.modelValue = ngModelCtrl.$viewValue;
            element.attr('aria-valuenow', ngModelCtrl.$viewValue);
            setSliderPercent(percent);
            thumbText.text( ngModelCtrl.$viewValue );
        }

        function minMaxValidator(value, minValue, maxValue) {
            if (angular.isNumber(value)) {
                minValue = angular.isNumber(minValue) ? minValue : min;
                maxValue = angular.isNumber(maxValue) ? maxValue : max;

                return Math.max(minValue, Math.min(maxValue, value));
            }
        }

        function stepValidator(value) {
            if (angular.isNumber(value)) {
                var formattedValue = (Math.round((value - min) / step) * step + min);
                formattedValue = (Math.round(formattedValue * Math.pow(10, round)) / Math.pow(10, round));

                if (formattedValue + step > max)
                    formattedValue = max;
                if (formattedValue - step < min)
                    formattedValue = min;

                if (containerCtrl && containerCtrl.fitInputWidthToTextLength){
                    $mdUtil.debounce(function () {
                        containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);
                    }, 100)();
                }

                return formattedValue;
            }
        }

        /**
         * @param percent 0-1
         */
        function setSliderPercent(percent) {

            percent = clamp(percent);

            var thumbPosition = (percent * 100) + '%';
            var activeTrackPercent = invert ? (1 - percent) * 100 + '%' : thumbPosition;

            if (vertical) {
                thumbContainer.css('bottom', thumbPosition);
            }
            else {
                $mdUtil.bidiProperty(thumbContainer, 'left', 'right', thumbPosition);
            }


            activeTrack.css(vertical ? 'height' : 'width', activeTrackPercent);

            element.toggleClass((invert ? 'ms-max' : 'ms-min'), percent === 0);
            element.toggleClass((invert ? 'ms-min' : 'ms-max'), percent === 1);
        }

        function getCurrentSharedSliderId() {
            var currentSharedSliderGroup = attr.group;
            var sharedSliders = angular.isDefined(vm.groups[currentSharedSliderGroup].sliders) ? vm.groups[currentSharedSliderGroup].sliders : [];

            for (var i = 0; i < sharedSliders.length; i++) {
                if (sharedSliders[i].element == element)
                    return i;
            }
        }

        /**
         * Slide listeners
         */
        var isDragging = false;

        function onPressDown(ev) {
            if (isDisabled()) return;

            //element.addClass('ms-active');
            element[0].focus();
            refreshSliderDimensions();

            var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
            var closestVal = minMaxValidator( stepValidator(exactVal) );
            scope.$apply(function() {
                setModelValue( closestVal );
                setSliderPercent( valueToPercent(closestVal));
            });
        }
        function onPressUp(ev) {
            if (isDisabled()) return;

            element.removeClass('ms-dragging');

            var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
            var closestVal = minMaxValidator( stepValidator(exactVal) );
            scope.$apply(function() {
                setModelValue(closestVal);
                ngModelRender();
            });
        }
        function onDragStart(ev) {
            if (isDisabled()) return;
            isDragging = true;
            ev.stopPropagation();

            element.addClass('ms-dragging');
            setSliderFromEvent(ev);
        }
        function onDrag(ev) {
            if (!isDragging) return;
            ev.stopPropagation();
            setSliderFromEvent(ev);
        }
        function onDragEnd(ev) {
            if (!isDragging) return;
            ev.stopPropagation();
            isDragging = false;
        }

        function setSliderFromEvent(ev) {
            // While panning discrete, update only the
            // visual positioning but not the model value.
            if ( discrete ) adjustThumbPosition( vertical ? ev.pointer.y : ev.pointer.x );
            else            doSlide( vertical ? ev.pointer.y : ev.pointer.x );
        }

        /**
         * Slide the UI by changing the model value
         * @param x
         */
        function doSlide( x ) {
            scope.$evalAsync( function() {
                setModelValue( percentToValue( positionToPercent(x) ));
            });
        }

        /**
         * Slide the UI without changing the model (while dragging/panning)
         * @param x
         */
        function adjustThumbPosition( x ) {
            var exactVal = percentToValue( positionToPercent( x ));
            var closestVal = minMaxValidator( stepValidator(exactVal) );
            setSliderPercent( positionToPercent(x) );
            thumbText.text( closestVal );
        }

        /**
         * Clamps the value to be between 0 and 1.
         * @param {number} value The value to clamp.
         * @returns {number}
         */
        function clamp(value) {
            return Math.max(0, Math.min(value || 0, 1));
        }

        /**
         * Convert position on slider to percentage value of offset from beginning...
         * @param position
         * @returns {number}
         */
        function positionToPercent( position ) {
            var offset = vertical ? sliderDimensions.top : sliderDimensions.left;
            var size = vertical ? sliderDimensions.height : sliderDimensions.width;
            var calc = (position - offset) / size;

            if (!vertical && $mdUtil.bidi() === 'rtl') {
                calc = 1 - calc;
            }

            return Math.max(0, Math.min(1, vertical ? 1 - calc : calc));
        }

        /**
         * Convert percentage offset on slide to equivalent model value
         * @param percent
         * @returns {*}
         */
        function percentToValue( percent ) {
            var adjustedPercent = invert ? (1 - percent) : percent;
            return (min + adjustedPercent * (max - min));
        }

        function valueToPercent( val ) {
            var percent = (val - min) / (max - min);
            return invert ? (1 - percent) : percent;
        }
    }
}
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, icoConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( icoConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( icoConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, icoGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: icoGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: icoGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msChooseFile', msChooseFileDirective);

    /** @ngInject */
    function msChooseFileDirective()
    {
        return {
            require : '^form',
            link: function (scope, elm, attrs, formCtrl) {
                var button = elm.find('button');
                var input = angular.element(elm[0].querySelector('input[data-hidden-file-input="1"]'));
                button.bind('click', function() {
                    input[0].click();
                });
                input.on('change', function(e) {
                    scope.$apply(function() {
                        var files = e.target.files;
                        if (files[0]) {
                            scope[input[0].id+'_fileName'] = files[0].name;
                            formCtrl.$setDirty();
                        } else {
                            scope[input[0].id+'_fileName'] = null;
                            formCtrl.$setPristine();
                        }
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msChange', msChangeDirective);

    /** @ngInject */
    function msChangeDirective()
    {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var onChangeHandler = scope.$eval(attrs.msChange);
                element.on('change', onChangeHandler);
                element.on('$destroy', function() {
                    element.off();
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();

(function ()
{
    'use strict';

    angular.module('app.navigation')
        .controller('ToastsController', ToastsController);

    function ToastsController($mdToast, data)
    {
        var vm = this;
        // Data
        vm.data = data;

        // Methods
        vm.closeToast = closeToast;

        //////////

        /**
         * Close toast
         */
        function closeToast()
        {
            $mdToast
                .hide()
                .then(function() {
                });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.users')
        .controller('UsersController', UsersController);

    /** @ngInject */
    function UsersController(api, $mdDialog, $scope, $compile, $resource, $rootScope, AUTH_EVENTS)
    {
        var vm = this;

        // Data
        vm.countries = { 'AF':'Afghanistan','AX':'Aland Islands','AL':'Albania','DZ':'Algeria','AS':'American Samoa','AD':'Andorra','AO':'Angola','AI':'Anguilla','AQ':'Antarctica','AG':'Antigua And Barbuda','AR':'Argentina','AM':'Armenia','AW':'Aruba','AU':'Australia','AT':'Austria','AZ':'Azerbaijan','BS':'Bahamas','BH':'Bahrain','BD':'Bangladesh','BB':'Barbados','BY':'Belarus','BE':'Belgium','BZ':'Belize','BJ':'Benin','BM':'Bermuda','BT':'Bhutan','BO':'Bolivia','BA':'Bosnia And Herzegovina','BW':'Botswana','BV':'Bouvet Island','BR':'Brazil','IO':'British Indian Ocean Territory','BN':'Brunei Darussalam','BG':'Bulgaria','BF':'Burkina Faso','BI':'Burundi','KH':'Cambodia','CM':'Cameroon','CA':'Canada','CV':'Cape Verde','KY':'Cayman Islands','CF':'Central African Republic','TD':'Chad','CL':'Chile','CN':'China','CX':'Christmas Island','CC':'Cocos (Keeling) Islands','CO':'Colombia','KM':'Comoros','CG':'Congo','CD':'Congo,Democratic Republic','CK':'Cook Islands','CR':'Costa Rica','CI':'Cote D\'Ivoire','HR':'Croatia','CU':'Cuba','CY':'Cyprus','CZ':'Czech Republic','DK':'Denmark','DJ':'Djibouti','DM':'Dominica','DO':'Dominican Republic','EC':'Ecuador','EG':'Egypt','SV':'El Salvador','GQ':'Equatorial Guinea','ER':'Eritrea','EE':'Estonia','ET':'Ethiopia','FK':'Falkland Islands (Malvinas)','FO':'Faroe Islands','FJ':'Fiji','FI':'Finland','FR':'France','GF':'French Guiana','PF':'French Polynesia','TF':'French Southern Territories','GA':'Gabon','GM':'Gambia','GE':'Georgia','DE':'Germany','GH':'Ghana','GI':'Gibraltar','GR':'Greece','GL':'Greenland','GD':'Grenada','GP':'Guadeloupe','GU':'Guam','GT':'Guatemala','GG':'Guernsey','GN':'Guinea','GW':'Guinea-Bissau','GY':'Guyana','HT':'Haiti','HM':'Heard Island & Mcdonald Islands','VA':'Holy See (Vatican City State)','HN':'Honduras','HK':'Hong Kong','HU':'Hungary','IS':'Iceland','IN':'India','ID':'Indonesia','IR':'Iran,Islamic Republic Of','IQ':'Iraq','IE':'Ireland','IM':'Isle Of Man','IL':'Israel','IT':'Italy','JM':'Jamaica','JP':'Japan','JE':'Jersey','JO':'Jordan','KZ':'Kazakhstan','KE':'Kenya','KI':'Kiribati','KR':'Korea','KW':'Kuwait','KG':'Kyrgyzstan','LA':'Lao People\'s Democratic Republic','LV':'Latvia','LB':'Lebanon','LS':'Lesotho','LR':'Liberia','LY':'Libyan Arab Jamahiriya','LI':'Liechtenstein','LT':'Lithuania','LU':'Luxembourg','MO':'Macao','MK':'Macedonia','MG':'Madagascar','MW':'Malawi','MY':'Malaysia','MV':'Maldives','ML':'Mali','MT':'Malta','MH':'Marshall Islands','MQ':'Martinique','MR':'Mauritania','MU':'Mauritius','YT':'Mayotte','MX':'Mexico','FM':'Micronesia,Federated States Of','MD':'Moldova','MC':'Monaco','MN':'Mongolia','ME':'Montenegro','MS':'Montserrat','MA':'Morocco','MZ':'Mozambique','MM':'Myanmar','NA':'Namibia','NR':'Nauru','NP':'Nepal','NL':'Netherlands','AN':'Netherlands Antilles','NC':'New Caledonia','NZ':'New Zealand','NI':'Nicaragua','NE':'Niger','NG':'Nigeria','NU':'Niue','NF':'Norfolk Island','MP':'Northern Mariana Islands','NO':'Norway','OM':'Oman','PK':'Pakistan','PW':'Palau','PS':'Palestinian Territory,Occupied','PA':'Panama','PG':'Papua New Guinea','PY':'Paraguay','PE':'Peru','PH':'Philippines','PN':'Pitcairn','PL':'Poland','PT':'Portugal','PR':'Puerto Rico','QA':'Qatar','RE':'Reunion','RO':'Romania','RU':'Russian Federation','RW':'Rwanda','BL':'Saint Barthelemy','SH':'Saint Helena','KN':'Saint Kitts And Nevis','LC':'Saint Lucia','MF':'Saint Martin','PM':'Saint Pierre And Miquelon','VC':'Saint Vincent And Grenadines','WS':'Samoa','SM':'San Marino','ST':'Sao Tome And Principe','SA':'Saudi Arabia','SN':'Senegal','RS':'Serbia','SC':'Seychelles','SL':'Sierra Leone','SG':'Singapore','SK':'Slovakia','SI':'Slovenia','SB':'Solomon Islands','SO':'Somalia','ZA':'South Africa','GS':'South Georgia And Sandwich Isl.','ES':'Spain','LK':'Sri Lanka','SD':'Sudan','SR':'Suriname','SJ':'Svalbard And Jan Mayen','SZ':'Swaziland','SE':'Sweden','CH':'Switzerland','SY':'Syrian Arab Republic','TW':'Taiwan','TJ':'Tajikistan','TZ':'Tanzania','TH':'Thailand','TL':'Timor-Leste','TG':'Togo','TK':'Tokelau','TO':'Tonga','TT':'Trinidad And Tobago','TN':'Tunisia','TR':'Turkey','TM':'Turkmenistan','TC':'Turks And Caicos Islands','TV':'Tuvalu','UG':'Uganda','UA':'Ukraine','AE':'United Arab Emirates','GB':'United Kingdom','US':'United States','UM':'United States Outlying Islands','UY':'Uruguay','UZ':'Uzbekistan','VU':'Vanuatu','VE':'Venezuela','VN':'Viet Nam','VG':'Virgin Islands,British','VI':'Virgin Islands,U.S.','WF':'Wallis And Futuna','EH':'Western Sahara','YE':'Yemen','ZM':'Zambia','ZW':'Zimbabwe' };

        vm.userFilter = {};
        vm.userFilters = {};

        vm.dtColumns = [
            {
                defaultContent: "",
                sTitle: "ID",
                mData: "id"
                //visible: false
            },
            {
                defaultContent: "",
                sTitle: "Name",
                mRender: function(data, type, row){
                    return (row.name?row.name:'') + ' ' + (row.surname?row.surname:'');
                }
            },
            {
                defaultContent: "",
                mData: "is_buyer",
                sTitle: "Buyer",
                render: function(data, type, row){
                    var kinds = {0:'No', 1:'Yes'};
                    return (typeof kinds[row.is_buyer] !== 'undefined')?kinds[row.is_buyer]:row.is_buyer;
                }
            },
            {
                defaultContent: "",
                mData: "is_airdropper",
                sTitle: "Airdropper",
                render: function(data, type, row){
                    var kinds = {0:'No', 1:'Yes'};
                    return (typeof kinds[row.is_airdropper] !== 'undefined')?kinds[row.is_airdropper]:row.is_airdropper;
                }
            },
            {
                defaultContent: "",
                mData: "email",
                sTitle: "Email"
            },
            {
                defaultContent: "",
                mData: "country_code",
                sTitle: "Country",
                mRender: function ( data, type, row, meta) {
                    return vm.countries[row.country_code];
                }
            },
            {
                defaultContent: "",
                mData: "access_level",
                sTitle: "Access Level",
                mRender: function ( data, type, row, meta) {
                    if (typeof row.access_level === "undefined" || !row.access_level)
                        row.access_level = "0";
                    var accessLevels = {"0":"Guest", "10":"User", "20":"Admin", "30":"Admin"};
                    var accessLevelBadges = {"0":"grey", "10":"green", "20":"red", "30":"red"};

                    return "<span class='badge-"+accessLevelBadges[row.access_level]+"'>"+accessLevels[row.access_level]+"</span>";
                }
            },
            {
                defaultContent: "",
                mData: "kyc_date_time_created",
                sTitle: "KYC Submit Date"
            },
            {
                defaultContent: "",
                mData: "kyc_level",
                sTitle: "KYC",
                mRender: function ( data, type, row, meta) {
                    return (row.kyc_level == 2)?"<span class='badge-green'>Complete</span>":
                        "<span class='badge-grey'>Incomplete</span>";
                }
            },
            {
                defaultContent: "",
                mData: "kyc_status",
                sTitle: "KYC Status",
                mRender: function ( data, type, row, meta) {
                    if (typeof row.kyc_status === "undefined" || !row.kyc_status)
                        row.kyc_status = "0";

                    var kycStatuses = {"0":"Not provided", "1":"In progress", "2":"Waiting for user", "3":"Approved", "4":"Declined"};
                    var kycStatusBadges = {"0":"grey", "1":"orange", "2":"grey", "3":"green", "4":"red"};

                    return "<span class='badge-"+kycStatusBadges[row.kyc_status]+"'>"+kycStatuses[row.kyc_status]+"</span>";
                }
            },
            {
                sTitle: "KYC",
                visible: true,
                mRender: function ( data, type, row, meta) {
                    return generateKycButton(row);
                }
            }
        ];
        vm.dtInstance = {};

        vm.dtOptions = {
            //dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            order: [[ 0, "desc" ]],
            columnDefs: [{
                targets: [ 1, -1 ],
                className: 'all'
            }],
            initComplete: function ()
            {

            },
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search",
                emptyTable: "No data available"
            },
            pageLength : 10,
            autoWidth: false,
            responsive: true,
            bLengthChange: false,
            processing: true,
            serverSide: true,
            bFilter: true, //remove search
            ajax: {
                url: api.baseUrl+'users/list',
                type: 'POST',
                dataSrc: 'data',
                data : vm.userFilters,
                dataFilter: function(data){
                    var json = jQuery.parseJSON(data);
                    if (typeof json.data.data === 'undefined' || json.data.data.length < 1)
                        json.data.data = [];
                    // return JSON string
                    return JSON.stringify(json.data);
                },
                error: function (response) {
                    $rootScope.$broadcast({
                        401: AUTH_EVENTS.sessionTimeout,
                        403: AUTH_EVENTS.notAuthorized,
                        419: AUTH_EVENTS.sessionTimeout,
                        440: AUTH_EVENTS.sessionTimeout
                    }[response.status], response);
                }
            },
            createdRow: createdRow
        };

        vm.dataLoading = {};
        vm.dataLoading.kyc_dialog = {};
        
        // Methods
        vm.showKycDialog = showKycDialog;
        vm.setUserFilters = setUserFilters;

        //////////

        function createdRow(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }

        //
        function setUserFilters() {
            vm.userFilters.filter = [];
            angular.forEach(vm.userFilter, function (value, index)
            {
                if (value) {
                    var filter = {
                        field: index,
                        data: {
                            type: 'numeric',
                            comparison: 'eq',
                            value: '1'
                        }
                    };
                    vm.userFilters.filter.push(filter);
                }
            });
        }

        // KYC dialog
        function showKycDialog(userId) {
            vm.dataLoading.kyc_dialog[userId] = true;
            $mdDialog.cancel();

            api.kyc.getDetails({id: userId}).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        vm.dataLoading.kyc_dialog[userId] = false;

                        $mdDialog.show({
                            controller         : 'KycDialogController',
                            controllerAs       : 'vm',
                            templateUrl        : 'app/main/users/dialogs/kyc/kyc-dialog.html',
                            parent             : angular.element('#content-container'),
                            fullscreen         : true, // Only for -xs, -sm breakpoints.
                            clickOutsideToClose: true,
                            escapeToClose      : true,
                            locals:            {
                                userKycDetails: response.data
                            }
                        });
                        
                    } else {
                        vm.dataLoading.kyc_dialog[userId] = false;
                        api.showToast('error', response.message[0]);
                    }
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        function generateKycButton(row) {
            if (typeof row.kyc_status === "undefined" || !row.kyc_status)
                row.kyc_status = "0";

            var buttonClass = (row.kyc_status==1)?"md-warn":"md-accent";
            var buttonLabel = (row.kyc_status==1)?"Verify":"Browse";
            return "<md-button class='md-raised "+buttonClass+" promise-button' aria-label='"+buttonLabel+"' " +
                        "ng-attr-data-loading='{{vm.dataLoading.kyc_dialog["+row.id+"]}}' " +
                        "ng-disabled='vm.dataLoading.kyc_dialog["+row.id+"] || "+ !row.kyc_id +" || "+ (row.kyc_status==0) +"' " +
                        "ng-click='vm.showKycDialog("+row.id+")'>" +
                        "<span class='promise-button-label'>"+buttonLabel+"</span>" +
                        "<md-progress-circular class='md-accent' md-mode='indeterminate' md-diameter='32'></md-progress-circular>" +
                    "</md-button>";
        }

        // API resources
        api.kyc = $resource(null, null, {
            'getDetails': {
                method          : 'GET',
                url             : api.baseUrl+'users/kyc_details'
            }
        });


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.transactions',
            [
                // 3rd Party Dependencies
                'datatables'
            ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.transactions', {
                url    : '/transactions',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/transactions/transactions.html',
                        controller : 'TransactionsController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.admin, USER_ROLES.god]
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/transactions');

        // Navigation
        msNavigationServiceProvider.saveItem('transactions', {
            title    : 'Transactions',
            icon     : 'icon-view-list',
            state    : 'app.transactions',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'TRANSACTIONS.TRANSACTIONS_NAV',
            weight   : 3
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.transactions')
        .controller('TransactionsController', TransactionsController);

    /** @ngInject */
    function TransactionsController(api, $rootScope, AUTH_EVENTS)
    {
        var vm = this;

        // Data
        vm.dtColumns = [
            {
                defaultContent: "",
                mData: "id",
                sTitle: "ID"
            },
            {
                defaultContent: "",
                mData: "kind",
                sTitle: "Type",
                render: function(data, type, row){
                    var kinds = {1:'Deposit', 2:'Token Issue', 3: 'Affiliate Reward', 4: 'Airdrop'};
                    return (typeof kinds[row.kind] !== 'undefined')?kinds[row.kind]:row.kind;
                }
            },
            {
                defaultContent: "",
                mData: "date_time_created",
                sTitle: "Date"
            },
            {
                defaultContent: "",
                mData: "status",
                sTitle: "Status"
            },
            {
                defaultContent: "",
                mData: "amount",
                sTitle: "Amount"
            },
            {
                defaultContent: "",
                mData: "currency_code",
                sTitle: "Currency"
            },
            {
                defaultContent: "",
                mData: "user_id",
                sTitle: "User ID"
            }
        ];
        vm.dtInstance = {};
        vm.dtOptions = {
            //dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            order: [[ 0, "desc" ]],
            columnDefs  : [],
            initComplete: function ()
            {

            },
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search",
                emptyTable: "No data available"
            },
            pageLength : 10,
            autoWidth: false,
            responsive: true,
            bLengthChange: false,
            processing: true,
            serverSide: true,
            bFilter: false, //remove search
            ajax: {
                url: api.baseUrl+'transactions/list',
                type: 'POST',
                dataSrc: 'data',
                dataFilter: function(data){
                    var json = jQuery.parseJSON(data);
                    if (typeof json.data.data === 'undefined' || json.data.data.length < 1)
                        json.data.data = [];
                    // return JSON string
                    return JSON.stringify(json.data);
                },
                error: function (response) {
                    $rootScope.$broadcast({
                        401: AUTH_EVENTS.sessionTimeout,
                        403: AUTH_EVENTS.notAuthorized,
                        419: AUTH_EVENTS.sessionTimeout,
                        440: AUTH_EVENTS.sessionTimeout
                    }[response.status], response);
                }
            }
        };
        // Methods


        //////////

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.settings', {
                url    : '/settings',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/settings.html',
                        controller : 'SettingsController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.admin, USER_ROLES.god]
                },
                resolve  : {
                    SettingsData: function (msApi)
                    {
                        return msApi.resolve('settings@getSettingsData');
                    }
                }
            });

        // Api
        msApiProvider.register('settings', ['settings', null, {
            'getSettingsData': {
                method          : 'GET',
                withCredentials : true
            }
        }]);

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/settings');

        // Navigation
        msNavigationServiceProvider.saveItem('settings', {
            title    : 'Settings',
            icon     : 'icon-gear',
            state    : 'app.settings',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'SETTINGS.SETTINGS_NAV',
            weight   : 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings')
        .controller('SettingsController', SettingsController);

    /** @ngInject */
    function SettingsController(SettingsData, api, $mdToast, $resource, session, $filter)
    {
        var vm = this;

        // Data
        vm.settingsData = SettingsData.data;
        vm.dataLoading = {};

        // Methods
        vm.addBonusRow = addBonusRow;
        vm.removeBonusRow = removeBonusRow;
        vm.setTokenPrice = setTokenPrice;
        vm.setBonus = setBonus;
        vm.setAffiliateReward = setAffiliateReward;

        //////////

        function showToast(type, message) {
            $mdToast.show({
                hideDelay   : 3500,
                position    : 'top right',
                controller  : 'ToastsController',
                controllerAs: 'vm',
                locals             : {
                    data         : {message: message}
                },
                templateUrl : 'app/navigation/toasts/'+type+'.html'
            });
        }

        function addBonusRow(bonusKind) {
            var bonusData = $filter('filter')(vm.settingsData.bonusData, {'kind':bonusKind}, true);
            var previousBonus = bonusData[bonusData.length - 1];
            var previousBonusToDateValue = (previousBonus && typeof previousBonus !== 'undefined')?previousBonus.to_date:'';
            var previousBonusToAmountValue = (previousBonus && typeof previousBonus !== 'undefined')?previousBonus.to_amount:'';
            vm.settingsData.bonusData.push(
                {
                    kind: bonusKind,
                    from_date: previousBonusToDateValue,
                    from_amount: previousBonusToAmountValue,
                    to_date: '',
                    to_amount: '',
                    bonus: '',
                    token_price: '',
                    soft_cap: '0'
                }
            );
        }

        function removeBonusRow(item) {
            var index = vm.settingsData.bonusData.indexOf(item);
            vm.settingsData.bonusData.splice(index, 1);
        }

        function setTokenPrice() {
            var formData = new FormData(document.getElementById('tokenPrice'));
            formData.append('token', session.token);

            api.settings.setTokenPrice(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        showToast('success', response.message[0]);
                    } else
                        showToast('error', response.message[0]);
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        function setBonus() {
            if (vm.settingsData.isBonusEnabled) {
                var formData = new FormData(document.getElementById('bonusForm'));
                formData.append('token', session.token);
                //this components are not a standard html inputs, need to append their value manually
                formData.append('is_bonus_enabled', vm.settingsData.isBonusEnabled);
                formData.append('bonus_kind', vm.settingsData.bonusKind);
            }else{
                var formData = new FormData();
                formData.append('token', session.token);
                formData.append('is_bonus_enabled', vm.settingsData.isBonusEnabled);
            }

            api.settings.setBonus(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        showToast('success', response.message[0]);
                    } else
                        showToast('error', response.message[0]);
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        function setAffiliateReward() {
            vm.dataLoading.affiliateForm = true;
            var formData = new FormData(document.getElementById('affiliateForm'));
            formData.append('isAffiliateEnabled', vm.settingsData.isAffiliateEnabled);
            formData.append('token', session.token);

            api.settings.setAffiliateReward(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        showToast('success', 'Affiliate settings saved');
                        vm.dataLoading.affiliateForm = false;
                    } else {
                        showToast('error', response.message[0]);
                        vm.dataLoading.affiliateForm = false;
                    }
                },
                //error
                function(response){
                    console.error(response);
                    vm.dataLoading.affiliateForm = false;
                }
            );
        }

        // API resources
        api.settings = $resource(null, null, {
            'setBonus': {
                method          : 'POST',
                url             : api.baseUrl+'settings/set_bonus',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'setTokenPrice': {
                method          : 'POST',
                url             : api.baseUrl+'settings/set_token_price',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'setAffiliateReward': {
                method          : 'POST',
                url             : api.baseUrl+'settings/affiliate',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            }
        });

        //populate bonus array if empty
        if(!$filter('filter')(vm.settingsData.bonusData, {'kind':0}, true).length)
            vm.settingsData.bonusData.push({kind:0});
        if(!$filter('filter')(vm.settingsData.bonusData, {'kind':0}, true).length)
            vm.settingsData.bonusData.push({kind:1});
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.purchases')
        .controller('PurchasesController', PurchasesController);

    /** @ngInject */
    function PurchasesController(PurchasesData, $rootScope, api, $mdDialog, $resource)
    {
        var vm = this;

        // Data
        vm.purchasesData = PurchasesData.data;
        vm.dataLoading = {};
        vm.dtInstance = {};

        vm.dtColumns = [
            {
                defaultContent: "",
                mData: "id",
                sTitle: "ID"
            },
            {
                defaultContent: "",
                mData: "user_id",
                sTitle: "User ID"
            },
            {
                defaultContent: "",
                mData: "status",
                sTitle: "Status",
                render: function ( data, type, row) {
                    if (typeof row.status === "undefined" || !row.status)
                        row.status = "0";

                    var mintageStatuses = {"0":"Unknown", "1":"Pending", "2":"Queued", "3":"Processed", "4":"Minting error"};
                    var mintageStatusBadges = {"0":"grey", "1":"orange", "2":"orange", "3":"green", "4":"red"};

                    return "<span class='badge-"+mintageStatusBadges[row.status]+"'>"+mintageStatuses[row.status]+"</span>";
                }
            },
            {
                defaultContent: "",
                mData: "SubID",
                sTitle: "subid"
            },
            {
                defaultContent: "",
                mData: "donated_currency_id",
                sTitle: "Donated currency",
                render: function ( data, type, row) {
                    if (typeof row.donated_currency_id === "undefined" || !row.donated_currency_id)
                        row.donated_currency_id = null;

                    if (row.donated_currency_id)
                        return vm.purchasesData.currencies[row.donated_currency_id].code;
                }
            },
            {
                defaultContent: "",
                mData: "donated_amount",
                sTitle: "Donated amount"
            },
            {
                defaultContent: "",
                mData: "received_currency_id",
                sTitle: "Received currency",
                render: function ( data, type, row) {
                    if (typeof row.received_currency_id === "undefined" || !row.received_currency_id)
                        row.received_currency_id = null;

                    if (row.received_currency_id)
                    return vm.purchasesData.currencies[row.received_currency_id].code;
                }
            },
            {
                defaultContent: "",
                mData: "received_amount",
                sTitle: "Received amount"
            },
            {
                defaultContent: "",
                mData: "received_txid",
                sTitle: "Received TX ID"
            },
            {
                defaultContent: "",
                mData: "tx_date_time",
                sTitle: "TX date"
            }
        ];

        vm.dtOptions = {
            //dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            order: [[ 0, "desc" ]],
            columnDefs  : [],
            initComplete: function ()
            {

            },
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search",
                emptyTable: "No data available"
            },
            pageLength : 10,
            autoWidth: false,
            responsive: true,
            bLengthChange: false,
            processing: true,
            serverSide: true,
            bFilter: false, //remove search
            ajax: {
                url: api.baseUrl+'list/mintage/list',
                type: 'POST',
                dataSrc: 'data',
                dataFilter: function(data){
                    var json = jQuery.parseJSON(data);
                    if (typeof json.data.data === 'undefined' || json.data.data.length < 1)
                        json.data.data = [];
                    // return JSON string
                    return JSON.stringify(json.data);
                },
                error: function (response) {
                    $rootScope.$broadcast({
                        401: AUTH_EVENTS.sessionTimeout,
                        403: AUTH_EVENTS.notAuthorized,
                        419: AUTH_EVENTS.sessionTimeout,
                        440: AUTH_EVENTS.sessionTimeout
                    }[response.status], response);
                }
            }
        };

        // Methods
        vm.showAddOfflineSaleDialog = showAddOfflineSaleDialog;

        //////////

        // KYC dialog
        function showAddOfflineSaleDialog() {
            vm.dataLoading.addPurchaseDialog = true;
            api.purchase.getDetails().$promise.then(
                //success
                function(response){
                    if (response.success) {
                        $mdDialog.show({
                            controller         : 'AddOfflineSaleDialogController',
                            controllerAs       : 'vm',
                            templateUrl        : 'app/main/purchases/dialogs/add-offline-sale/add-offline-sale-dialog.html',
                            parent             : angular.element('#content-container'),
                            fullscreen         : true, // Only for -xs, -sm breakpoints.
                            clickOutsideToClose: true,
                            escapeToClose      : true,
                            locals:            {
                                offlineSaleDetails: response.data
                            },
                            onRemoving         : function(){
                                vm.dtInstance.DataTable.draw();
                            }
                        });
                        vm.dataLoading.addPurchaseDialog = false;
                    } else {
                        vm.dataLoading.addPurchaseDialog = false;
                        api.showToast('error', 'Failed to load dialog');
                    }
                },
                //error
                function(response){
                    console.error(response);
                }
            );

        }

        //vm.showAddOfflineSaleDialog();

        // API resources
        api.purchase = $resource(null, null, {
            'getDetails': {
                method          : 'GET',
                url             : api.baseUrl+'offline_mintage'
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.overview', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.overview', {
                url    : '/overview',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/overview/overview.html',
                        controller : 'OverviewController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.admin, USER_ROLES.god]
                },
                resolve  : {
                    OverviewData: function (msApi)
                    {
                        return msApi.resolve('overview@getOverviewData');
                    }
                }
            });

        // Api
        msApiProvider.register('overview', ['overview', null, {
            'getOverviewData': {
                method          : 'GET',
                withCredentials : true
            }
        }]);

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/overview');

        // Navigation
        msNavigationServiceProvider.saveItem('overview', {
            title    : 'Overview',
            icon     : 'icon-view-quilt',
            state    : 'app.overview',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'OVERVIEW.OVERVIEW_NAV',
            weight   : 0
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.overview')
        .controller('OverviewController', OverviewController);

    /** @ngInject */
    function OverviewController(OverviewData)
    {
        var vm = this;

        // Data
        vm.overviewData = OverviewData.data;
        vm.stats = vm.overviewData[vm.overviewData.defaultBaseCurrency];

        vm.stats.goals.unshift({amount: 0, title: 'Token sales start'});
        vm.stats.goals.sort(function(a, b) {return (a.amount>b.amount)?1:((b.amount>a.amount)?-1:0)});

        vm.stats.setCurrentGoal = function (num, arr) {
            vm.stats.currentGoal = {};

            for (var i = 0; i < arr.length; i++) {
                if (num >= arr[i].amount) {
                    vm.stats.goals[i].passed = true;
                    if(vm.stats.goals[i-1] && vm.stats.goals[i-1].current)
                        vm.stats.goals[i-1].current = false;
                    vm.stats.goals[i].current = true;

                    vm.stats.currentGoal.index = i<arr.length-1?i:i-1;
                    vm.stats.currentGoal.amount = i<arr.length-1?vm.stats.goals[i].amount:vm.stats.goals[i-1].amount;
                    vm.stats.currentGoal.nextGoalAmount = i<arr.length-1?vm.stats.goals[i+1].amount:vm.stats.goals[i].amount;
                }
            }
        };

        vm.stats.setCurrentGoal(vm.stats.totalCoinValue, vm.stats.goals);

        vm.dtInstance = {};
        vm.dtOptions = {
            //dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            paging: false,
            bFilter: false,
            bInfo: false,
            order: [[ 1, "desc" ]],
            columnDefs  : [
                {
                    "targets": [0],
                    "orderable": false
                },
                {
                    targets: [ 0, 1 ],
                    className: 'all'
                }
            ],
            initComplete: function ()
            {

            },
            language: {
                emptyTable: "No data available"
            },
            pageLength  : 10,
            autoWidth: false,
            responsive  : true,
            bLengthChange: false
        };

        // Methods

        //////////

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('icoTheming', icoThemingService);

    /** @ngInject */
    function icoThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, icoPalettes, icoThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            icoThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(false);

        // Define custom palettes
        angular.forEach(icoPalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(icoThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var icoThemes = {
        default  : {
            primary   : {
                name: 'grey',
                hues: {
                    'default': '900',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'ico-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('icoThemes', icoThemes);
})();
(function () {
    'use strict';

    var icoPalettes = [
        {
            name: 'ico-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'ico-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('icoPalettes', icoPalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('icoGenerator', icoGeneratorService);

    /** @ngInject */
    function icoGeneratorService($cookies, $log, icoTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(icoTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(icoTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            icoTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                icoTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                icoTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, icoTheming)
    {
        var vm = this;

        // Data
        vm.themes = icoTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            icoTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return icoTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the ico theme options panel
                        $mdSidenav('ico-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('session', session);

    /** @ngInject */
    function session($rootScope)
    {

        var service = this;

        //Data
        service.user = {};
        // Methods
        service.create = create;
        service.setToken = setToken;
        service.setClientCountry = setClientCountry;
        service.destroy = destroy;
        
        return service;

        //////////

        function create(user)
        {
            service.user = user;
            $rootScope.user = user;
        }

        function setToken(token)
        {
            service.token = token;
        }

        function setClientCountry(country_code)
        {
            service.clientCountry = country_code;
        }

        function destroy()
        {
            service.user = {role:0};
            $rootScope.user = {role:0};
        }


    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(baseUrl + apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(baseUrl + apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('auth', auth);

    /** @ngInject */
    function auth($resource, session, api)
    {
        // Private variables
        var service = {
            isAuthenticated         : isAuthenticated,
            isAuthorized            : isAuthorized
        };

        //Data
        var baseUrl = api.baseUrl;

        api.auth = $resource(null, null, {
            'login': {
                method          : 'POST',
                url             : baseUrl+'account/login',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'logout': {
                method          : 'GET',
                url             : baseUrl+'account/logout',
                withCredentials : true
            },
            'signup': {
                method          : 'POST',
                url             : baseUrl+'account/signup',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'changePassword': {
                method          : 'POST',
                url             : baseUrl+'account/change_password',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'activate2fa': {
                method          : 'POST',
                url             : baseUrl+'account/activate_2fa',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'changeSettings': {
                method          : 'POST',
                url             : baseUrl+'account/change_settings',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'getAccountData': {
                method          : 'GET',
                url             : baseUrl+'account',
                withCredentials : true
            },
            'getGoogleAuthData': {
                method          : 'GET',
                url             : baseUrl+'account/google_auth_data',
                withCredentials : true
            },
            'verifyGoogleAuthCode': {
                method          : 'POST',
                url             : baseUrl+'account/verify_google_auth_code',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            }
        });
        
        return service;

        //////////

        /**
         * Checks if user is authenticated
         *
         * @returns (boolean)
         */
        function isAuthenticated()
        {
            return session.user?!!session.user.userId:false;
        }

        /**
         * Checks if user is authorized
         *
         * @param authorizedRoles
         * @returns (boolean)
         */

        function isAuthorized(authorizedRoles)
        {
            if (!angular.isArray(authorizedRoles))
                authorizedRoles = [authorizedRoles];
            return session.user?(authorizedRoles.indexOf(session.user.role) !== -1):false;
        }
    }
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('authResolver', authResolverService);

    /** @ngInject */
    function authResolverService($q, $rootScope)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve auth
         */
        function resolve()
        {
            var deferred = $q.defer();
            var unwatch = $rootScope.$watch('user', function (user) {
                if (angular.isDefined(user)) {
                    if (user) {
                        deferred.resolve(user);
                    } else {
                        deferred.reject();
                    }
                    unwatch();
                }
            });
            
            //return the promise
            return deferred.promise;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('authInterceptor', authInterceptor);

    /** @ngInject **/
    function authInterceptor($rootScope, $q, AUTH_EVENTS)
    {
        return {
            responseError: function (response) {
                $rootScope.$broadcast({
                    401: AUTH_EVENTS.sessionTimeout,
                    403: AUTH_EVENTS.notAuthorized,
                    419: AUTH_EVENTS.sessionTimeout,
                    440: AUTH_EVENTS.sessionTimeout
                }[response.status], response);
                return $q.reject(response);
            }
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiInterceptor', apiInterceptor);

    /** @ngInject **/
    function apiInterceptor($rootScope, $q, API_EVENTS)
    {
        return {
            responseError: function (response) {
                $rootScope.$broadcast(API_EVENTS.error, response);
                return $q.reject(response);
            }
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
    (function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('icoConfig', icoConfigProvider);

    /** @ngInject */
    function icoConfigProvider()
    {
        // Default configuration
        var icoConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true,
            'site'                           : {
                'name'                       : 'Administration',
                'htmlName'                   : '<b>CEEK</b>',
                'shortName'                  : 'CEEK',
                'tokenName'                  : 'CEEK',
                'tokenCode'                  : 'CEEK',
                'isCaptchaEnabled'           : false,
                'timezone'                   : '-0700' //PT
            },
            'recaptcha'                      : {
                'theme'                      : 'light',
                'key'                        : '6LdfCE8UAAAAAPCx5BeT6T-MV1_5POadBHkEXNkj'
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            icoConfiguration = angular.extend({}, icoConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(icoConfiguration[configName]) )
                {
                    return false;
                }

                return icoConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                icoConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, msNavigationService, api, AUTH_EVENTS)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');

        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.logout = logout;
        vm.toggleSidenav = toggleSidenav;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            api.auth.logout().$promise.then(
                //success
                function(){
                    $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
                },
                //error
                function(response){
                    console.error(response);
                }
            );
            
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Ico
     */
    angular
        .module('ico', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Overview
            'app.overview',

            // Settings
            'app.settings',

            // Users
            'app.users',

            // Transactions
            'app.transactions',

            // Purchases
            'app.purchases',
            
            // Authentication
            'app.auth.login'
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('ico')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, icoGenerator, icoConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        icoGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( icoConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .constant('AUTH_EVENTS', {
            loginSuccess : 'auth-login-success',
            loginFailed : 'auth-login-failed',
            logoutSuccess : 'auth-logout-success',
            sessionTimeout : 'auth-session-timeout',
            notAuthenticated : 'auth-not-authenticated',
            notAuthorized : 'auth-not-authorized'
        })
        .constant('API_EVENTS', {
            error: 'api-error'
        })
        .constant('USER_ROLES', {
            all: "*",
            god: 30,
            admin: 20,
            user: 10,
            guest: 0
        })
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, icoConfigProvider, $compileProvider, $httpProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|btc|bitcoin|eth|ether|ethereum|ltc|litecoin|dash):/);

        // http interceptors
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('apiInterceptor');

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Ico theme configurations
        icoConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('ico')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $window, $mdDialog, api, session, auth, AUTH_EVENTS, API_EVENTS)
    {
        var toState = {},
            fromState = {};

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, currentState, stateParams, previousState)
        {
            if (currentState.external) {
                event.preventDefault();
                $window.open(currentState.url, currentState.blank?'_blank':'_self');
            } else {
                toState = currentState;
                toState.params = stateParams;
                fromState = previousState;

                var authorizedRoles = currentState.data.authorizedRoles;

                if (!auth.isAuthorized(authorizedRoles)) {
                    event.preventDefault();
                    if (angular.isDefined(session.user) && angular.isDefined(session.user.role)){
                        if (auth.isAuthenticated()) {
                            //user is not allowed
                            $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
                        } else {
                            //user is not logged in
                            $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
                        }
                    }
                } else {
                    $mdDialog.cancel();
                    $rootScope.loadingProgress = true;
                }
            }
        });

        //Get user data
        api.auth.getAccountData().$promise.then(
            //success
            function(response){
                if (response.success){
                    session.setToken(response.data.token);
                    session.setClientCountry(response.data.client_country);
                    if (response.success && angular.isDefined(response.data.userId)){
                        response.data.toState = toState;
                        $rootScope.$broadcast(AUTH_EVENTS.loginSuccess, response.data);
                    } else
                        $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated, toState);
                } else {
                    $rootScope.$broadcast(API_EVENTS.error, {status:'Can\'t get user token'});
                }
            },
            //error
            function(response){
                console.error(response);
            }
        );

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('ico')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        //$urlRouterProvider.otherwise('/deposit');
        $urlRouterProvider.otherwise( function($injector) {
            var $state = $injector.get("$state");
            $state.go("app.overview");
        });

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }
                },
                resolve: {
                    auth: function resolveAuthentication(authResolver) {
                        return authResolver.resolve();
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('ico')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(icoTheming, $scope, $state, $rootScope, session, USER_ROLES, AUTH_EVENTS, API_EVENTS, auth, icoConfig)
    {
        var vm = this;

        // Data
        vm.themes = icoTheming.themes;
        $rootScope.apiError = null;
        $rootScope.user = null;
        $rootScope.site = icoConfig.getConfig('site');
        $scope.userRoles = USER_ROLES;
        //$scope.isAuthorized = auth.isAuthorized;

        // Methods
        vm.loginSuccess = loginSuccess;
        vm.logoutSuccess = logoutSuccess;
        vm.notAuthorized = notAuthorized;
        vm.notAuthenticated = notAuthenticated;
        vm.sessionTimeout = sessionTimeout;
        vm.showApiError = showApiError;

        //listen to auth events
        $rootScope.$on(AUTH_EVENTS.notAuthorized, vm.notAuthorized);
        $rootScope.$on(AUTH_EVENTS.notAuthenticated, vm.notAuthenticated);
        $rootScope.$on(AUTH_EVENTS.sessionTimeout, vm.sessionTimeout);
        $rootScope.$on(AUTH_EVENTS.logoutSuccess, vm.logoutSuccess);
        $rootScope.$on(AUTH_EVENTS.loginSuccess, vm.loginSuccess);

        //listen to api events
        $rootScope.$on(API_EVENTS.error, vm.showApiError);

        //////////

        function loginSuccess(event, data) {
            session.create(data);
            //continue state change?
            if (data.toState)
                $state.go(data.toState.name, data.toState.params);
        }

        function logoutSuccess() {
            session.destroy();
            $state.go('app.login');
        }

        function showApiError(event, data) {
            $rootScope.apiError = data;
            $rootScope.apiError.message = 'response status code is '+data.status;
        }

        function notAuthorized() {
            session.user.role>10?$state.go('app.overview'):$state.go('app.login');
        }

        function notAuthenticated(event, data) {
            session.destroy();
            //continue state change?
            if (data)
                $state.go(data.name, data.params);
            else
                $state.go('app.login');
        }

        function sessionTimeout() {
            session.destroy();
            $state.go('app.login');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('ico');
})();

(function ()
{
    'use strict';

    angular
        .module('ico')
        .config(config);

    /** @ngInject */
    function config($translateProvider, msApiProvider)
    {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');
        
        // API base URL
        msApiProvider.setBaseUrl('api/api__');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('ico')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, msApi, $mdToast)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = msApi.getBaseUrl();


        api.showToast = function(type, message) {
            $mdToast.show({
                hideDelay   : 3500,
                position    : 'top right',
                controller  : 'ToastsController',
                controllerAs: 'vm',
                locals             : {
                    data         : {message: message}
                },
                templateUrl : 'app/navigation/toasts/'+type+'.html'
            });
        };

        return api;
    }

})();
angular.module("ico").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex>{{userlo}}\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"ico-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/overview/overview.html","<div id=\"overview\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header\"><span \nclass=\"md-display-1 font-weight-300\">Overview</span></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab \nlabel=\"Sales\"><div class=\"progress-bar-wrapper mb-24\"><div class=\"status-bar\" \nng-style=\"{width: 100-100/vm.stats.goals.length+\'%\'}\"><div class=\"current-status\" style=\"width: 0\" \nng-style=\"{width: (100-100/(vm.stats.goals.length-1))*\r\n                                     (vm.stats.currentGoal.index)+((100/(vm.stats.goals.length-1))/100*\r\n                                     ((vm.stats.totalCoinValue-vm.stats.currentGoal.amount)*100)/\r\n                                     (vm.stats.currentGoal.nextGoalAmount-vm.stats.currentGoal.amount))+\'%\',\r\n                                     transition: \'width \'+vm.stats.goals.length*300+\'ms linear\'}\">\n</div><div class=\"current-amount\" style=\"left: 0\" \nng-style=\"{left: (100-100/(vm.stats.goals.length-1))*\r\n                                     (vm.stats.currentGoal.index)+((100/(vm.stats.goals.length-1))/100*\r\n                                     ((vm.stats.totalCoinValue-vm.stats.currentGoal.amount)*100)/\r\n                                     (vm.stats.currentGoal.nextGoalAmount-vm.stats.currentGoal.amount))+\'%\',\r\n                                     transition: \'all \'+vm.stats.goals.length*300+\'ms linear\'}\">\n<span>{{vm.stats.totalCoinValue | number : 3}} {{vm.stats.baseCurrency}}</span></div></div><ul class=\"progress-bar\"><li\n ng-repeat=\"(key, goal) in vm.stats.goals\" class=\"section\" \nng-style=\"{width: 100/vm.stats.goals.length+\'%\', transition: \'all \'+key*700+\'ms linear\'}\" \nng-class=\"{visited: goal.passed, current: goal.current}\"><span class=\"goal-title\">{{goal.title}}</span> <span \nclass=\"goal-amount\">{{goal.amount>0?(goal.amount | number)+\' \'+vm.stats.baseCurrency:\'\'}}</span></li></ul></div><div \nclass=\"overview-card md-whiteframe-1dp\"><div class=\"h2 secondary-text\">Sales</div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Accepted\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{vm.stats.baseCurrency}} Equivalent</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">USD Equivalent</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, currency) in vm.stats.currencies\"><td class=\"title\"><i \nng-class=\"[\'cryptoicon-{{key}}\', \'cryptoicon-{{key}}-bg\']\"></i> <span hide-xs>{{currency.title}}</span></td><td>\n{{currency.invested}}</td><td>{{currency.coinValue | number}} {{vm.stats.baseCurrency}}</td><td>\n{{vm.overviewData.USD.currencies[currency.code].coinValue | number}} USD</td></tr></tbody></table></div><div \nclass=\"overview-card inline-stats-card md-whiteframe-1dp\"><div class=\"stats-header\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"space-around center\"><div class=\"stats-header-unit\" layout=\"column\" layout-align=\"center\"><span \nclass=\"stats-header-amount\">{{vm.stats.salesStats.sold | number}} {{site.tokenCode}} </span><span \nclass=\"stats-header-description\">Total tokens sold</span></div><div class=\"stats-header-unit\" layout=\"column\" \nlayout-align=\"center\"><span class=\"stats-header-amount\">{{vm.overviewData.USD.totalCoinValue | number : 2}} USD </span>\n<span class=\"stats-header-description\">Total sales value (USD)</span></div><div class=\"stats-header-unit\" \nlayout=\"column\" layout-align=\"center\"><span class=\"stats-header-amount\">\n{{vm.stats.totalCoinValue | number}} {{vm.stats.baseCurrency}} </span><span class=\"stats-header-description\">\nTotal sales value ({{vm.stats.baseCurrency}})</span></div></div></div></md-tab><md-tab label=\"Users\"><div \nclass=\"overview-card inline-stats-card md-whiteframe-1dp\"><div class=\"stats-header\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"space-around center\"><div class=\"stats-header-unit\" layout=\"column\" layout-align=\"center\"><span \nclass=\"stats-header-amount\">{{vm.overviewData.userStats.total?vm.overviewData.userStats.total:0}} </span><span \nclass=\"stats-header-description\">Total Users</span></div><div class=\"stats-header-unit\" layout=\"column\" \nlayout-align=\"center\"><span class=\"stats-header-amount\">\n{{vm.overviewData.userStats.kyc[3]?vm.overviewData.userStats.kyc[3]:0}} </span><span class=\"stats-header-description\">\nKYC Approved</span></div><div class=\"stats-header-unit\" layout=\"column\" layout-align=\"center\"><span \nclass=\"stats-header-amount\">{{vm.overviewData.userStats.kyc[1]?vm.overviewData.userStats.kyc[1]:0}} </span><span \nclass=\"stats-header-description\">KYC Pending</span></div><div class=\"stats-header-unit\" layout=\"column\" \nlayout-align=\"center\"><span class=\"stats-header-amount\">\n{{vm.overviewData.userStats.kyc[4]?vm.overviewData.userStats.kyc[4]:0}} </span><span class=\"stats-header-description\">\nKYC Rejected</span></div></div></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/purchases/purchases.html","<div id=\"purchases\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header\"><span \nclass=\"md-display-1 font-weight-300\">Purchases</span></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab \nlabel=\"Purchases list\"><div class=\"purchases-card md-whiteframe-1dp\"><div class=\"h2 secondary-text\" layout=\"row\">\nPurchases <span flex></span><md-button class=\"md-raised md-accent tab-header-button promise-button\" \naria-label=\"Add offline purchase\" ng-attr-data-loading=\"{{vm.dataLoading.addPurchaseDialog}}\" \nng-disabled=\"vm.dataLoading.addPurchaseDialog\" ng-click=\"vm.showAddOfflineSaleDialog()\"><span \nclass=\"promise-button-label\">Add offline purchase</span><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></div><table \nclass=\"dataTable row-border hover\" datatable dt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"></table></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/settings/settings.html","<div id=\"settings\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header\"><span \nclass=\"md-display-1 font-weight-300\">Settings</span></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab \nlabel=\"General settings\"><div layout=\"row\" layout-wrap><div class=\"settings-card md-whiteframe-1dp\" flex flex-sm=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"49\" layout-wrap><div class=\"h2 secondary-text\">Base token price</div><div \nclass=\"card-content base-token-price\"><form name=\"tokenPrice\" id=\"tokenPrice\" layout=\"column\"><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex-gt-xs><label>Price of 1 token</label><input type=\"number\" minlength=\"0\" \nmd-no-asterisk=\"true\" disabled=\"disabled\" name=\"tokenPrice\" ng-model=\"vm.settingsData.tokenPrice\"><div class=\"hint\">\n1 token = {{(!vm.settingsData.tokenPrice && vm.settingsData.tokenCurrencyId)?0:vm.settingsData.tokenPrice}} {{vm.settingsData.currencies[vm.settingsData.tokenCurrencyId]}}\n</div></md-input-container><md-input-container><label>Currency</label><md-select \nng-model=\"vm.settingsData.tokenCurrencyId\" name=\"tokenCurrencyId\" md-no-asterisk=\"true\" disabled=\"disabled\"><md-option \nng-repeat=\"(id, code) in vm.settingsData.currencies\" ng-value=\"id\">{{code}}</md-option></md-select>\n</md-input-container></div></form></div></div><div class=\"settings-card md-whiteframe-1dp\" flex flex-sm=\"100\" \nflex-xs=\"100\" flex-gt-sm=\"49\" layout-wrap ng-show=\"vm.settingsData.tokenPrice && vm.settingsData.bonusFactor\"><div \nclass=\"h2 secondary-text\">Current token price</div><div class=\"card-content current-token-price\">\n1 Token = {{(vm.settingsData.tokenPrice/vm.settingsData.bonusFactor) | currency : \"$\"}} <span class=\"hint\">\nincluding {{((vm.settingsData.bonusFactor - 1) * 100) | number : 2}}% bonus</span></div></div></div><div \nclass=\"settings-card md-whiteframe-1dp\"><form id=\"bonusForm\"><div class=\"h2 secondary-text\">Bonuses</div><div \nclass=\"card-content\" ng-show=\"vm.settingsData.bonusKind==0\" layout=\"column\"><div class=\"blur-wrapper\" \nng-class=\"{\'disabled\':!vm.settingsData.isBonusEnabled}\"><div layout-gt-xs=\"row\" \nng-repeat=\"bonus in vm.settingsData.bonusData | filter: {kind: 0} as bonusByDate\"><md-input-container class=\"md-block\" \nflex-gt-xs><label>Start date</label><md-datepicker ng-model=\"bonus.from_date\" required></md-datepicker><input \ntype=\"hidden\" ng-value=\"bonus.from_date | date:\'yyyy-MM-dd HH:mm:ss\'\" \nname=\"bonus_data[{{vm.settingsData.bonusData.indexOf(bonus)}}][from_date]\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>End date</label><md-datepicker ng-model=\"bonus.to_date\" required></md-datepicker>\n<input type=\"hidden\" ng-value=\"bonus.to_date | date:\'yyyy-MM-dd HH:mm:ss\'\" \nname=\"bonus_data[{{vm.settingsData.bonusData.indexOf(bonus)}}][to_date]\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Bonus</label><input type=\"number\" minlength=\"0\" maxlength=\"100\" required \nng-model=\"bonus.bonus\" name=\"bonus_data[{{vm.settingsData.bonusData.indexOf(bonus)}}][bonus]\"><div class=\"hint\">\nBonus amount (percent)</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Token Price\n</label><input type=\"number\" required ng-model=\"bonus.token_price\" \nname=\"bonus_data[{{vm.settingsData.bonusData.indexOf(bonus)}}][token_price]\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Soft Cap</label><input type=\"number\" ng-model=\"bonus.soft_cap\" \nname=\"bonus_data[{{vm.settingsData.bonusData.indexOf(bonus)}}][soft_cap]\"></md-input-container><div \nclass=\"row-button-container\"><md-button ng-show=\"bonusByDate.length > 1\" class=\"bonus-button md-raised md-warn\" \nng-click=\"vm.removeBonusRow(bonus)\">Remove</md-button></div><input type=\"hidden\" ng-value=\"bonus.kind\" \nname=\"bonus_data[{{vm.settingsData.bonusData.indexOf(bonus)}}][kind]\"></div></div><div class=\"actions\"><md-button \nclass=\"bonus-button md-raised md-accent\" ng-class=\"{\'disabled\':!vm.settingsData.isBonusEnabled}\" \nng-click=\"vm.addBonusRow(vm.settingsData.bonusKind)\">Add</md-button><md-button class=\"bonus-button md-raised btn-save\" \nng-click=\"vm.setBonus()\">Save</md-button></div></div><div class=\"card-content\" ng-show=\"vm.settingsData.bonusKind==1\" \nlayout=\"column\"><div class=\"blur-wrapper\" ng-class=\"{\'disabled\':!vm.settingsData.isBonusEnabled}\"><div \nlayout-gt-xs=\"row\" ng-repeat=\"bonus in vm.settingsData.bonusData | filter: {kind: 1} as bonusByTokenAmount\">\n<md-input-container class=\"md-block\" flex-gt-xs><label>From</label><input type=\"text\" ng-model=\"bonus.from_amount\" \nrequired name=\"bonus_data[{{vm.settingsData.bonusData.indexOf(bonus)}}][from_amount]\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label>To</label><input type=\"text\" ng-model=\"bonus.to_amount\" \nrequired name=\"bonus_data[{{vm.settingsData.bonusData.indexOf(bonus)}}][to_amount]\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label>Bonus</label><input type=\"number\" minlength=\"0\" maxlength=\"100\" \nrequired ng-model=\"bonus.bonus\" name=\"bonus_data[{{vm.settingsData.bonusData.indexOf(bonus)}}][bonus]\"><div \nclass=\"hint\">Bonus amount (percent)</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\nToken Price</label><input type=\"number\" required ng-model=\"bonus.token_price\" \nname=\"bonus_data[{{vm.settingsData.bonusData.indexOf(bonus)}}][token_price]\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Soft Cap</label><input type=\"number\" ng-model=\"bonus.soft_cap\" \nname=\"bonus_data[{{vm.settingsData.bonusData.indexOf(bonus)}}][soft_cap]\"></md-input-container><div \nclass=\"row-button-container\"><md-button ng-show=\"bonusByTokenAmount.length > 1\" class=\"bonus-button md-raised md-warn\" \nng-click=\"vm.removeBonusRow(bonus)\">Remove</md-button></div><input type=\"hidden\" ng-value=\"bonus.kind\" \nname=\"bonus_data[{{vm.settingsData.bonusData.indexOf(bonus)}}][kind]\"></div></div><div class=\"actions\"><md-button \nclass=\"bonus-button md-raised md-accent\" ng-class=\"{\'disabled\':!vm.settingsData.isBonusEnabled}\" \nng-click=\"vm.addBonusRow(vm.settingsData.bonusKind)\">Add</md-button><md-button class=\"bonus-button md-raised btn-save\" \nng-click=\"vm.setBonus($event)\">Save</md-button></div></div></form></div></md-tab><md-tab label=\"Affiliate settings\">\n<div class=\"settings-card md-whiteframe-1dp\"><form name=\"affiliateForm\" id=\"affiliateForm\" layout=\"column\" \nng-submit=\"vm.setAffiliateReward()\"><div class=\"h2 secondary-text\"><md-checkbox \nng-model=\"vm.settingsData.isAffiliateEnabled\" name=\"isAffiliateEnabled\" ng-true-value=\"1\" ng-false-value=\"0\" \naria-label=\"Enable Affiliate\">Enable Affiliate</md-checkbox></div><div class=\"card-content short-content\">\n<md-input-container class=\"md-block\" flex-gt-xs><label>Reward</label><input type=\"number\" minlength=\"0\" \nmd-no-asterisk=\"true\" name=\"affiliateReward\" ng-model=\"vm.settingsData.affiliateReward\"><div class=\"hint\">\nAffiliate reward percent</div></md-input-container><div class=\"actions\"><md-button \nclass=\"bonus-button md-raised promise-button md-accent submit-button\" type=\"submit\" \nng-attr-data-loading=\"{{vm.dataLoading.affiliateForm}}\" \nng-disabled=\"affiliateForm.$pristine || affiliateForm.$invalid || vm.dataLoading.affiliateForm\"><span \nclass=\"promise-button-label\">Save</span><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular></md-button></div></div></form></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/transactions/transactions.html","<div id=\"transactions\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header\"><span \nclass=\"md-display-1 font-weight-300\">Transactions</span><div class=\"csv-export\"><md-button \nhref=\"api/api__transactions/export\" title=\"Export CSV\" target=\"_blank\" aria-label=\"Users CSV\" class=\"md-raised\">\nExport CSV</md-button></div></div><div class=\"content\"><div class=\"transactions-card md-whiteframe-1dp\"><table \ndatatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" class=\"row-border hover\"></table></div></div></div>");
$templateCache.put("app/main/users/users.html","<div id=\"users\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header\" layout=\"row\"><div><span \nclass=\"md-display-1 font-weight-300\">Users</span><div class=\"csv-export\"><md-button href=\"api/api__users/export\" \ntitle=\"Export CSV\" target=\"_blank\" aria-label=\"Users CSV\" class=\"md-raised\">Export CSV</md-button></div></div><span \nflex></span><div class=\"filters\"><h4 class=\"mt-0 mb-10\">Filters:</h4><div><md-checkbox class=\"inverted mb-10\" \naria-label=\"Buyers\" ng-model=\"vm.userFilter.is_buyer\" ng-change=\"vm.setUserFilters()\">Buyers</md-checkbox></div><div>\n<md-checkbox class=\"inverted mb-10\" aria-label=\"Airdroppers\" ng-model=\"vm.userFilter.is_airdropper\" \nng-change=\"vm.setUserFilters()\">Airdroppers</md-checkbox></div></div><div class=\"stats-header\" layout=\"row\" hide \nlayout-align=\"space-around center\"><div class=\"stats-header-unit\" layout=\"column\" layout-align=\"center\"><span \nclass=\"stats-header-amount\">{{}} </span><span class=\"stats-header-description\">Total Users</span></div><div \nclass=\"stats-header-unit\" layout=\"column\" layout-align=\"center\"><span class=\"stats-header-amount\">{{}} </span><span \nclass=\"stats-header-description\">KYC Approved</span></div><div class=\"stats-header-unit\" layout=\"column\" \nlayout-align=\"center\"><span class=\"stats-header-amount\">{{}} </span><span class=\"stats-header-description\">KYC Pending\n</span></div><div class=\"stats-header-unit\" layout=\"column\" layout-align=\"center\"><span class=\"stats-header-amount\">\n{{}} </span><span class=\"stats-header-description\">KYC Rejected</span></div></div></div><div class=\"content\"><div \nclass=\"users-card md-whiteframe-1dp\"><table datatable dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" \nclass=\"row-border hover\"></table></div></div></div>");
$templateCache.put("app/navigation/toasts/error.html","<md-toast class=\"error\"><span class=\"md-toast-text\" flex>{{vm.data.message}}</span></md-toast>");
$templateCache.put("app/navigation/toasts/success.html","<md-toast class=\"success\"><span class=\"md-toast-text\" flex>{{vm.data.message}}</span></md-toast>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" layout=\"row\" layout-align=\"start\"><div id=\"login-intro\" flex hide show-gt-sm><div \nclass=\"intro-description\">Administration</div></div><div id=\"login-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-form\"><div class=\"logo\" hide-gt-sm><span>Admin\n</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><div class=\"description\" \ntranslate=\"LOGIN.DESCRIPTION\">Please make sure you at <a href=\"https://tokensale.ceek.io\">https://tokensale.ceek.io</a>\n</div><form name=\"loginForm\" id=\"loginForm\" ng-submit=\"vm.login($event)\"><md-input-container class=\"md-block\" \nmd-no-float><label translate=\"LOGIN.EMAIL\">Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><label translate=\"LOGIN.PASSWORD\">Password\n</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" required autocomplete=\"new-password\"><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label>Google authenticator code</label><input type=\"text\" \nname=\"code\" ng-model=\"vm.form.code\" ng-maxlength=\"6\" ng-minlength=\"6\" required><div \nng-messages=\"loginForm.code.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.CODE_REQUIRED\">Google authenticator code is required</span></div><div \nng-message=\"maxlength, minlength\"><span translate=\"LOGIN.ERRORS.CODE_LENGTH\">Code must be exactly 6 characters long\n</span></div></div></md-input-container><div class=\"grecaptcha\" \nng-if=\"vm.clientCountry != \'CN\' && site.isCaptchaEnabled\" vc-recaptcha key=\"vm.recaptcha.key\" \non-create=\"vm.setWidgetId(widgetId)\"></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button promise-button\" aria-label=\"LOG IN\" ng-attr-data-loading=\"{{vm.dataLoading}}\" \nng-disabled=\"loginForm.$invalid || vm.dataLoading\" translate-attr-aria-label=\"LOGIN.LOG_IN\"><span \nclass=\"promise-button-label\" translate=\"LOGIN.LOG_IN\">LOG IN</span><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></form></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">{{site.shortName}}</span> <span \nclass=\"logo-text\">{{$root.site.name}}</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide \nshow-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" \nfolded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"https://www.gravatar.com/avatar/{{user.gravatar}}?s=40&d=identicon\"></div><span class=\"username\" hide \nshow-gt-xs>{{user.name?user.name:user.email}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\">\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<div class=\"navigation-container\"><ul flex=\"grow\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n</div><script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/purchases/dialogs/add-offline-sale/add-offline-sale-dialog.html","<md-dialog aria-label=\"Add Offline Sale\" id=\"add-offline-sale-dialog\"><div class=\"dialog-container\" flex ng-cloak>\n<md-toolbar><div class=\"md-toolbar-tools\"><div flex layout=\"column\"><h3>Add Offline Sale</h3></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form id=\"addOfflineSaleForm\" name=\"addOfflineSaleForm\" \nng-submit=\"vm.addOfflineSale($event)\"><p>Incoming transaction:</p><div layout-gt-sm=\"row\"><md-autocomplete flex \nrequired md-input-name=\"currency\" md-selected-item=\"vm.offlineSaleDetails.selectedCurrency\" \nmd-selected-item-change=\"vm.tryCalculateMintage()\" md-search-text-change=\"vm.tryCalculateMintage()\" \nmd-search-text=\"vm.offlineSaleDetails.selectedCurrencyText\" \nmd-items=\"currency in vm.offlineSaleDetails.currenciesArray | filter:vm.offlineSaleDetails.selectedCurrencyText\" \nmd-item-text=\"currency.name\" md-min-length=\"0\" md-floating-label=\"Currency\" md-require-match md-autofocus \nmd-select-on-focus md-autoselect md-select-on-match><md-item-template><span \nmd-highlight-text=\"vm.offlineSaleDetails.selectedCurrencyText\" md-highlight-flags=\"^i\">{{currency.name}}</span>\n</md-item-template><div ng-messages=\"addOfflineSaleForm.currency.$error\" ng-if=\"addOfflineSaleForm.currency.$touched\">\n<div ng-message=\"required\">You must select a currency.</div><div ng-message=\"md-require-match\">\nPlease select a currency.</div></div></md-autocomplete><md-input-container class=\"md-block\" flex-gt-sm><label>Amount\n</label><input type=\"number\" step=\"any\" name=\"payment_amount\" required ng-model=\"vm.offlineSaleDetails.amount\" \nng-change=\"vm.tryCalculateMintage()\"></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.offlineSaleDetails.selectedCurrency\" \nng-show=\"vm.offlineSaleDetails.selectedCurrency.id != vm.offlineSaleDetails.tokenPriceCurrencyId\"><md-input-container \nclass=\"md-block short-input\" flex-gt-sm><md-autocomplete flex required md-input-name=\"payment_currency_rate\" \nmd-selected-item=\"vm.offlineSaleDetails.exchangeRate\" md-selected-item-change=\"vm.tryCalculateMintage()\" \nmd-search-text-change=\"vm.tryCalculateMintage()\" md-search-text=\"vm.offlineSaleDetails.exchangeRateText\" \nmd-items=\"rate in [vm.getCurrencyRate(vm.offlineSaleDetails.selectedCurrency.code)]\" md-item-text=\"rate\" \nmd-min-length=\"0\" md-floating-label=\"Conversion rate\" \nng-init=\"vm.offlineSaleDetails.exchangeRate=vm.offlineSaleDetails.exchangeRateText=\r\n                                         vm.offlineSaleDetails.exchangeRates[vm.offlineSaleDetails.selectedCurrency.code.toLowerCase()].toString()\">\n<md-item-template><span>{{vm.offlineSaleDetails.selectedCurrency.code}} rate: ${{rate}}</span></md-item-template><div \nng-messages=\"addOfflineSaleForm.payment_currency_rate.$error\" \nng-if=\"addOfflineSaleForm.payment_currency_rate.$touched\"><div ng-message=\"required\">Please enter a currency rate.\n</div></div></md-autocomplete></md-input-container><div class=\"input-addition\">\n{{vm.offlineSaleDetails.currencies[vm.offlineSaleDetails.tokenPriceCurrencyId].code}}</div></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>Tx ID</label><input name=\"txid\" \nng-model=\"vm.offlineSaleDetails.tx_id\"></md-input-container></div><p>Outcoming transaction:</p><div layout=\"row\">\n<md-input-container class=\"md-block short-input\" flex-gt-sm><md-autocomplete flex required md-input-name=\"token_price\" \nmd-selected-item=\"vm.offlineSaleDetails.tokenPrice\" md-selected-item-change=\"vm.tryCalculateMintage()\" \nmd-search-text-change=\"vm.tryCalculateMintage()\" md-search-text=\"vm.offlineSaleDetails.tokenPriceText\" \nmd-items=\"bonus in vm.offlineSaleDetails.bonuses | filter:{kind:0} | filter:vm.offlineSaleDetails.tokenPriceText\" \nmd-item-text=\"bonus.token_price.toString()\" md-min-length=\"0\" md-floating-label=\"Token price\"><md-item-template><span>\n{{bonus.token_price}}</span></md-item-template><div ng-messages=\"addOfflineSaleForm.token_price.$error\" \nng-if=\"addOfflineSaleForm.token_price.$touched\"><div ng-message=\"required\">Select a token price.</div></div>\n</md-autocomplete></md-input-container><div class=\"input-addition\">\n{{vm.offlineSaleDetails.currencies[vm.offlineSaleDetails.tokenPriceCurrencyId].code}}</div></div><div layout=\"row\">\n<md-input-container class=\"md-block short-input\" flex-gt-sm><md-autocomplete flex required md-input-name=\"bonus\" \nmd-selected-item=\"vm.offlineSaleDetails.tokenBonus\" md-selected-item-change=\"vm.tryCalculateMintage()\" \nmd-search-text-change=\"vm.tryCalculateMintage()\" md-search-text=\"vm.offlineSaleDetails.tokenBonusText\" \nmd-items=\"bonus in vm.offlineSaleDetails.bonuses | filter:{kind:0} | filter:vm.offlineSaleDetails.tokenBonusText\" \nmd-item-text=\"bonus.bonus.toString()\" md-min-length=\"0\" md-floating-label=\"Token bonus\"><md-item-template><span>\n{{bonus.bonus}}</span></md-item-template><div ng-messages=\"addOfflineSaleForm.bonus.$error\" \nng-if=\"addOfflineSaleForm.bonus.$touched\"><div ng-message=\"required\">Select a token bonus.</div></div>\n</md-autocomplete></md-input-container><div class=\"input-addition\">%</div><div ng-show=\"vm.calculatedMintageAmount\" \nclass=\"calculated-mintage-amount\">User will receive <b>{{vm.calculatedMintageAmount}}</b>\n {{$root.site.tokenName}} tokens</div></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-sm>\n<md-autocomplete flex required md-input-name=\"receiver\" md-selected-item=\"vm.offlineSaleDetails.receiver\" \nmd-search-text=\"vm.offlineSaleDetails.receiverText\" md-items=\"user in vm.findUser(vm.offlineSaleDetails.receiverText)\" \nmd-item-text=\"user.email?user.email:user.ether_address\" \nmd-search-text-change=\"vm.offlineSaleDetails.recentUserPurchases = null\" \nmd-selected-item-change=\"vm.getRecentPurchases(user.id)\" md-min-length=\"0\" md-floating-label=\"Receiver\" md-delay=\"200\" \nng-pattern=\"/(^.+@.+\\..+$|^(0x)?[0-9a-fA-F]{40}$)/\"><md-item-template><div layout=\"column\" class=\"user-result\" \nlayout-align=\"center start\" ng-if=\"user.email && user.name && user.ether_address\"><span class=\"user-result-name\" \nmd-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{user.name + \' \' + user.surname}} </span><span \nclass=\"user-result-email\">{{user.email}}</span></div><div layout=\"column\" class=\"user-result\" \nlayout-align=\"center start\" ng-if=\"user.email && !user.ether_address\"><span class=\"user-result-name\" \nmd-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{user.email}}</span></div><div layout=\"column\" \nclass=\"user-result\" layout-align=\"center start\" ng-if=\"!user.email && user.ether_address\"><span \nclass=\"user-result-name\" md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{user.ether_address}}</span></div>\n</md-item-template><div ng-messages=\"addOfflineSaleForm.receiver.$error\" ng-if=\"addOfflineSaleForm.receiver.$touched\">\n<div ng-message=\"required\">Select a receiver.</div><div ng-message=\"pattern\">Must be a valid email or ether address.\n</div></div></md-autocomplete></md-input-container></div><div \nng-if=\"addOfflineSaleForm.receiver.$touched && vm.offlineSaleDetails.recentUserPurchases.length\"><p class=\"mt-0\">\nRecent receiver purchases:</p><div ng-repeat=\"purchase in vm.offlineSaleDetails.recentUserPurchases | limitTo:3\"><span>\n{{purchase.received_amount}} <b>{{vm.offlineSaleDetails.currencies[purchase.received_currency_id].code}}</b></span> \n<span>for</span> <span>{{purchase.donated_amount}} <b>\n{{vm.offlineSaleDetails.currencies[purchase.donated_currency_id].code}}</b></span></div></div><div class=\"disclaimer\" \nng-if=\"addOfflineSaleForm.receiver.$touched && vm.offlineSaleDetails.receiverText &&\r\n                vm.processReceiverInput(vm.offlineSaleDetails.receiverText, vm.offlineSaleDetails.receiver)\">\n<span>{{vm.receiverHint}}</span></div><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-warn\" \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\"><span>Cancel</span></md-button><span flex></span><md-button \ntype=\"submit\" class=\"md-raised md-accent promise-button\" aria-label=\"Add\" \nng-attr-data-loading=\"{{vm.dataLoading.addOfflineSale}}\" \nng-disabled=\"addOfflineSaleForm.$pristine || addOfflineSaleForm.$invalid || vm.dataLoading.addOfflineSale\"><span \nclass=\"promise-button-label\">Add</span><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog-content></div></md-dialog>");
$templateCache.put("app/main/users/dialogs/kyc/kyc-dialog.html","<md-dialog aria-label=\"KYC\" id=\"kyc-dialog\" ng-class=\"{\'document-fullscreen\' : vm.showImage}\"><div \nclass=\"dialog-container\" flex ng-cloak ng-hide=\"vm.showImage\"><md-toolbar><div class=\"md-toolbar-tools\"><div flex \nlayout=\"column\"><h3>{{vm.userKycDetails.user_name}} {{vm.userKycDetails.user_surname}} KYC</h3><div class=\"kyc-date\">\nSubmitted on {{vm.userKycDetails.kyc.date_time_created}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"kyc\" ng-show=\"!vm.isKycDeclined\"><form id=\"kycForm\" name=\"kycForm\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>First name</label><input name=\"name\" \nng-model=\"vm.userKycDetails.user_name\" required disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Last Name</label><input name=\"surname\" ng-model=\"vm.userKycDetails.user_surname\" \nrequired disabled=\"disabled\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>Address</label><input name=\"address_1\" ng-model=\"vm.userKycDetails.kyc.address_1\" required \ndisabled=\"disabled\"></md-input-container><md-input-container md-no-float class=\"md-block\" flex-gt-sm><label>Address 2\n</label><input name=\"address_2\" ng-model=\"vm.userKycDetails.kyc.address_2\" disabled=\"disabled\"></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>Country</label><input \nname=\"country_code\" ng-model=\"vm.countries[vm.userKycDetails.kyc.country_code]\" required disabled=\"disabled\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>City</label><input name=\"city\" \nng-model=\"vm.userKycDetails.kyc.city\" required disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Postal Code</label><input name=\"postal_code\" \nng-model=\"vm.userKycDetails.kyc.postal_code\" required disabled=\"disabled\"></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>Mobile phone</label><input \nname=\"mobile_phone\" ng-model=\"vm.userKycDetails.kyc.mobile_phone\" disabled=\"disabled\"></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>ID or passport number</label><input \nname=\"passport\" ng-model=\"vm.userKycDetails.kyc.passport\" required disabled=\"disabled\"></md-input-container>\n<md-input-container><label>Birth date</label><md-datepicker name=\"date_of_birth\" \nng-model=\"vm.userKycDetails.kyc.date_of_birth\" md-current-view=\"year\" required disabled=\"disabled\"></md-datepicker>\n</md-input-container></div><div layout-gt-xs=\"row\" class=\"documents\"><md-card ng-click=\"vm.openImage(\'passport\')\" \nclass=\"document\"><img ng-src=\"/api/documents/thumbs/{{vm.userKycDetails.kyc.images.passport}}\" alt=\"Passport\" \nclass=\"md-card-image\"><md-card-title><md-card-title-text><span class=\"md-headline\">ID/Passport</span>\n</md-card-title-text></md-card-title></md-card><md-card ng-click=\"vm.openImage(\'photo_holding_passport\')\" \nclass=\"document\"><img ng-src=\"/api/documents/thumbs/{{vm.userKycDetails.kyc.images.photo_holding_passport}}\" \nalt=\"Selfie\" class=\"md-card-image\"><md-card-title><md-card-title-text><span class=\"md-headline\">Selfie</span>\n</md-card-title-text></md-card-title></md-card><md-card ng-click=\"vm.openImage(\'por\')\" class=\"document\"><img \nng-src=\"/api/documents/thumbs/{{vm.userKycDetails.kyc.images.por}}\" alt=\"POR\" class=\"md-card-image\"><md-card-title>\n<md-card-title-text><span class=\"md-headline\">Proof of residence</span></md-card-title-text></md-card-title></md-card>\n</div></form><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-warn\" aria-label=\"Decline\" \nng-click=\"vm.isKycDeclined = true\"><span class=\"promise-button-label\">Decline</span></md-button><span flex></span>\n<md-button type=\"submit\" class=\"md-raised md-accent promise-button\" aria-label=\"Approve\" \nng-attr-data-loading=\"{{vm.dataLoading.approve}}\" ng-disabled=\"vm.dataLoading.approve\" ng-click=\"vm.approve($event)\">\n<span class=\"promise-button-label\">Approve</span><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular></md-button></md-dialog-actions></md-dialog-content><md-dialog-content \nclass=\"decline-message\" ng-show=\"vm.isKycDeclined\"><form id=\"declineForm\" name=\"declineForm\"><div \nclass=\"decline-reason-quick\"><div>Decline reason:</div><span ng-click=\"vm.addDeclineMessage(\'fake\')\">Fake documents\n</span> <span ng-click=\"vm.addDeclineMessage(\'blurred\')\">Blurred documents</span> <span \nng-click=\"vm.addDeclineMessage(\'unsupported\')\">Unsupported country</span> <span \nng-click=\"vm.addDeclineMessage(\'duplicate\')\">Duplicate documents</span> <span \nng-click=\"vm.addDeclineMessage(\'resolution\')\">Resolution is too small</span></div><md-input-container class=\"md-block\" \nflex-gt-sm><label>Message to user</label><textarea class=\"decline-message\" name=\"message\" \nng-model=\"vm.decline_message\" md-maxlength=\"500\" md-select-on-focus required>\r\n\r\n                    </textarea><div \nng-messages=\"declineForm.decline_message.$error\"><div ng-message=\"required\">Decline reason required</div></div>\n</md-input-container></form><md-dialog-actions layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Decline\" ng-click=\"vm.isKycDeclined = false\"><span class=\"promise-button-label\">Back</span></md-button>\n<span flex></span><md-button type=\"submit\" class=\"md-raised md-warn promise-button\" aria-label=\"Decline\" \nng-attr-data-loading=\"{{vm.dataLoading.decline}}\" ng-disabled=\"vm.dataLoading.decline\" ng-click=\"vm.decline($event)\">\n<span class=\"promise-button-label\">Decline</span><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular></md-button></md-dialog-actions></md-dialog-content></div><div \nclass=\"dialog-container document-fullscreen\" flex ng-cloak ng-show=\"vm.showImage\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h3>\n{{vm.userKycDetails.user_name}} {{vm.userKycDetails.user_surname}} {{vm.showImage==\'passport\'?\"passport\":\"proof of residence\"}}\n</h3><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.showImage = false\"><md-icon \nmd-font-icon=\"icon-arrow-left\" aria-label=\"Back\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"document-image\"><img ng-src=\"/api/documents/{{vm.userKycDetails.kyc.images[vm.showImage]}}\" \nalt=\"{{vm.showImage}}\"></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-raised md-accent\" aria-label=\"Back\" ng-click=\"vm.showImage = false\">Back</md-button></md-dialog-actions>\n</div></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);